import React, { Component } from "react";
// import AutosuggestComponent from '../../../../Utility/Components/AutosuggestComponent';
import OrganizationModalContent from "./Components/OrganizationModalContent";
import { useTranslation, withTranslation, Trans } from "react-i18next";

import { AgGridReact } from "@ag-grid-community/react";
import { InfiniteRowModelModule } from "@ag-grid-community/infinite-row-model";
import '@ag-grid-community/styles/ag-grid.css';
import '@ag-grid-community/styles/ag-theme-alpine.css';
import * as OrganizationController from "./Controller/OrganizationController";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import ConfirmationAlert from "../../../Utility/Components/ConfirmationAlert";
import { loaderStateTrue, loaderStateFalse } from "../../../Actions/AllAction";
import {
    setToken,
    setUserCredentials,
    logOutApp,
} from "../../../GlobalModules/Login/Actions/LoginAction";
import CustomInput from "../../../Utility/Components/CustomInput";
import Utility from "../../../Utility/Utility";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import ModalGlobal from "../../../Utility/Components/ModalGlobal";
import HomeUtility from "../../Utility/Utility";
import moment from "moment";
import Switch from "react-switch";
import { Tooltip as ReactTooltip } from 'react-tooltip';
import Config from "../../../Utility/Config";
import GridActionContent from "../../../Utility/Components/GridActionContent";
import BootstrapSwitchButton from "bootstrap-switch-button-react";
import AddUserModalContent from "./Components/AddUserModalContent";
import GlobalHeaderFilter from "../../../Utility/Components/GlobalHeaderFilter";
import OrganisationFilterContent from "../../../Utility/Components/OrganisationFilterContent";
import ErrorBoundary from "../../../Utility/Components/ErrorBoundary";
import CustomButton from "../../../Utility/Components/CustomButton";
import axios from "axios";
import ControlPannelModalContent from "./Components/ControlPannelModalContent"; // for control pannel
import WebhookSettingsModalContent from "./Components/WebhookSettingsModalContent";

class Organization extends Component {
    constructor(props) {
        super(props);
        (this.state = {
            modules: [InfiniteRowModelModule],
            tooltipShowDelay: 0,
            viewCheckListModal: false,
            // for webhook setting
            viewWebhookSettingModal: false,
            webhookSettingText: {
                fb_token_text: "",
                client_id_text: "",
                whatsapp_account_id_text: "",
                event_call_back_api_text: "",
            },
            webhookSettingError: {
                fb_token_error: "",
                client_id_error: "",
                whatsapp_account_id_error: "",
                event_call_back_api_error: "",
            },
            // end webhook setting
            // for control pannel
            viewControlPannelModal: false,
            orgNameControlPannelModal: "",
            ControlPannelModalDataset: [],
            selectedTab: "tab_captions",
            screenOptionsData: [],
            tabScreenOptionsSelectedValue: "",
            gridScreenOptionsSelectedValue: "",
            tabScreenTableData: [],
            gridScreenTableData: [],
            tabScreenOptionsSelectedError: "",
            gridScreenOptionsSelectedError: "",
            // end for control pannel
            orgSettingDataset: [],
            columnDefs: [
                {
                    headerName: "",
                    field: "logo_url",
                    //...this.getFieldDetails("logo_url"), // for control pannel added
                    //width: 65,
                    maxWidth: 72,
                    //cellRenderer: 'loadingRenderer',
                    cellRenderer: (params) => {
                        if (params && params.data) {
                            if (params.data.logo_url) {
                                let logoUrl = JSON.parse(params.data.logo_url);
                                return (
                                    <div className="gridusericon">
                                        <img src={logoUrl.img_url} />
                                    </div>
                                );
                            } else {
                                //return <img src="https://www.ag-grid.com/example-assets/loading.gif" />
                                return (
                                    <div className="default_org_img">
                                        <img
                                            src={require("../../../Utility/Public/images/usericon.png")}
                                        />
                                    </div>
                                );
                            }
                        } else {
                            return (
                                <img src="https://www.ag-grid.com/example-assets/loading.gif" />
                            );
                        }
                    },
                },
                {
                    headerName: "Organization Name",
                    field: "organization_name",
                    //...this.getFieldDetails("organization_name"), // for control pannel added
                    minWidth: 400,
                    cellRenderer: (params) => {
                        if (params && params.data) {
                            return <div>{params.data.name}</div>;
                        } else {
                            return null;
                        }
                    },
                },
                {
                    headerName: "Plan Description",
                    field: "version_description",
                    //...this.getFieldDetails("version_description"), // for control pannel added
                    minWidth: 250,
                    cellRenderer: (params) => {
                        if (params && params.data) {
                            return <div>{params.data.version_description}</div>;
                        } else {
                            return null;
                        }
                    },
                },
                {
                    headerName: "Is Webhook Setup?",
                    field: "",
                    minWidth: 150,
                    cellRenderer: (params) => {
                        if (params && params.data) {
                            return <div>{params?.data?.is_registered ? "Yes" : "No"}</div>;
                        } else {
                            return null;
                        }
                    },
                },
                // {
                //     headerName: "Check List",
                //     field: "",
                //     minWidth: 200,
                //     cellRenderer: (params) => {
                //         if (params && params.data) {
                //             return <div className="infoviewicon view-icon-btn" onClick={this.viewChecklist.bind(this, params.data)}>
                //                 <OverlayTrigger overlay={<Tooltip>View checklist</Tooltip>}>
                //                     <img className='checklist_img' src={require('../../../Utility/Public/images/checklist.png')} />
                //                 </OverlayTrigger>
                //             </div>
                //         } else {
                //             return null;
                //         }
                //     },
                // },
                {
                    headerName: "",
                    field: "",
                    minWidth: 80,
                    cellRenderer: (params) => {
                        if (params && params.data) {
                            return (
                                <div>
                                    {this.props.userCredentials?.user_details?.user_type !=
                                        "user" && (
                                            <OverlayTrigger
                                                overlay={<Tooltip>Download secret key</Tooltip>}
                                            >
                                                <CustomButton
                                                    onClick={() => {
                                                        this.downloadeSecreteKey(params.data);
                                                    }}
                                                    className="downloadsecretkeybtn"
                                                    children={
                                                        <img
                                                            src={require("../../../Utility/Public/images/key.png")}
                                                            className="downloadsecretkeybtn_img"
                                                        />
                                                    }
                                                />
                                            </OverlayTrigger>
                                        )}
                                </div>
                            );
                        } else {
                            return null;
                        }
                    },
                },
                {
                    headerName: "",
                    field: "active",
                    //...this.getFieldDetails("active"), // for control pannel added
                    minWidth: 80,
                    //resizable: true
                    cellRenderer: (params) => {
                        if (params) {
                            if (params.data) {
                                return (
                                    <button className="edittext">
                                        {this.props.userCredentials.hasOwnProperty(
                                            "user_details"
                                        ) &&
                                            this.props.userCredentials.user_details &&
                                            this.props.userCredentials.user_details.hasOwnProperty(
                                                "user_type"
                                            ) &&
                                            this.props.userCredentials.user_details.user_type ==
                                            "app_admin" ? (
                                            <div className="toggleSwitchBox_appAdmin">
                                                <div className="switch_btn_customize">
                                                    <BootstrapSwitchButton
                                                        onlabel="Active"
                                                        onstyle="success"
                                                        offlabel="Inactive"
                                                        offstyle="danger"
                                                        style={"w-60 mx-2"}
                                                        checked={
                                                            params.data && params.data.active
                                                                ? params.data.active
                                                                : false
                                                        }
                                                        onChange={() =>
                                                            this.handleChangeSwitchButton(params.data)
                                                        }
                                                    />
                                                </div>
                                            </div>
                                        ) : null}
                                    </button>
                                );
                            } else {
                                return null;
                            }
                        } else {
                            return null;
                        }
                    },
                },
                {
                    headerName: "",
                    field: "edit",
                    // ...this.getFieldDetails("edit"), // for control pannel added
                    minWidth: 90,
                    cellRenderer: (params) => {
                        if (params.data) {
                            return (
                                <div className="actionablePopup">
                                    {this.props.userCredentials?.user_details?.user_type !=
                                        "user" && (
                                            <button
                                                className="ellipsisIcon"
                                                onClick={this.actionModalfunction.bind(this, params)}
                                            >
                                                <i className="fa fa-ellipsis-v"></i>
                                            </button>
                                        )}
                                </div>
                            );
                        } else {
                            return null;
                        }
                    },
                },
            ],
            defaultColDef: {
                flex: 1,
                //resizable: true,
                minWidth: 90,
            },
            components: {
                loadingRenderer: (params) => {
                    //console.log("params=================== worker", params)
                    //return null;
                    if (params.value !== undefined) {
                        return params.value;
                    } else {
                        return '<img src="https://www.ag-grid.com/example-assets/loading.gif">';
                    }
                },
            },

            //Organization Tab State
            organizationModal: false,

            //Org img add
            addProfileImagePreviewShow: false,
            addprofileImageSelected: require("../../../Utility/Public/images/uploadicon.png"),
            addProfileImageError: "",

            // User Image Add
            addUserImagePreviewShow: false,
            addUserImageSelected: require("../../../Utility/Public/images/profile-back.png"),
            addUserImageError: "",

            //IMage crop
            src: null,
            crop: {
                unit: "%",
                width: 30,
                aspect: 1 / 1,
            },
            croppedImageUrl: "",

            imageCropModalFlag: false,

            fromData: {
                organization_name: "",
                profileImage: "",
                org_id: "",
                whatsapp_api_endpoint: "",
                phone_number_id: "",
                token: "",
                marketed_by_name: "",
                marketed_by_url: "",
                selectedVersion: [],
                contractStartDate: "",
                contractEndDate: "",
                whatsapp_business_account_id: "",
                facebook_app_id: "",
                delay_time: "0.00",
                is_mfa_required: false,
                user_count: "",
                balance_marketing_message: "",
                balance_utility_message: "",
                marketing_message: "",
                utility_message: "",
            },
            fromDataError: {
                organization_name: "",
                whatsapp_api_endpoint: "",
                phone_number_id: "",
                token: "",
                marketed_by_name: "",
                marketed_by_url: "",
                selectedVersion: "",
                contractStartDate: "",
                contractEndDate: "",
                whatsapp_business_account_id: "",
                facebook_app_id: "",
                delay_time: "",
                is_mfa_required: false,
                user_count: "",
                balance_marketing_message: "",
                balance_utility_message: "",
                marketing_message: "",
                utility_message: "",
            },
            statusList: [
                { label: "Active", value: "Active" },
                { label: "Inactive", value: "Inactive" },
            ],
            actionModalflag: false,
            deleteConfirmationAlertModal: false,
            gridObjData: "",
            addUserModalFlag: false,

            //Add User From Data
            addUserFromData: {
                name: "",
                email: "",
                //"phone": "",
                //"address": "",
                profileImage: "",
                status: true,
                user_id: "",
            },

            addUserFromDataError: {
                name: "",
                email: "",
            },
            addUserInfoFromData: {
                city: "",
                country: "",
                phone_no: "",
            },
            addUserInfoFromDataError: {
                city: "",
                country: "",
                phone_no: "",
            },

            //orgDataEditFlag: false,
            userDataEditFlag: false,
            imageEditFrom: "",
            deleteButtonEnableFlagForGridActionContent: false,

            deleteUserConfirmationAlertModal: false,
            userDeleteBodySecondContent: "",
            userDeleteObj: "",
            orgAddEditModalTitle: "",
            orgName: "",
            //saveButtonDisableEditModal: true,

            //file upload
            documentObjFileName: this.props.t("choosefile"),
            documentObjfileObj: "",
            documentError: "",
            versionOption: this.props.version,
            handleChangeVersionFlag: false,

            freeTrialSubscription: false,
            monthlySubscription: false,
            yearlySubscription: false,

            isCheckboxChecked: false,
            showMessageCountFields: false,

            zoominzoomoutflag: "",

            // handleChangeUserInformationPhoneNumberFlag: false,
            whatsappBusinessPhoneNumberError: "",
            whatsappBusinessPhoneNumber: "",
            whatsappBusinessPhoneNumberNote: false,
            totalDatasetCount: 0,

            changeCatelogToggle: false,
            uniqIdentifier: "",
            uniqIdentifierOptionsData: [],
            settingData: "",
            settingDataError: [],
            settingmasterData: [],

            tagsValue: [],
            tagsOptions: [],
        }),
            (this.gridOptions = {
                infiniteInitialRowCount: 1,
                //onGridReady,
                paginationPageSize: 100,
                rowBuffer: 0,
                rowModelType: "infinite",
                suppressCellSelection: true,
                suppressHorizontalScroll: true,
            }),
            (this.codeOutsideClickRef = React.createRef());
    }

    //========== for added control pannel ================//
    getFieldDetails = (fieldName) => {
        const fieldData = this.props.gridLableData.find(
            (item) => item.field_name == fieldName
        );
        return {
            headerName:
                fieldData?.modified_field_caption || fieldData?.field_caption || "",
            field: fieldName != "" ? fieldData?.field_name : "",
            hide: fieldData?.current_status != 1,
        };
    };
    //========== end for added control pannel ================//

    viewChecklist = (data) => {
        let dataHash = {};
        let filters = {};
        dataHash["org_id"] = data.id;
        filters["filters"] = JSON.stringify(dataHash);
        loaderStateTrue();
        const promise = new Promise((resolve, reject) => {
            OrganizationController.getOrgSetting(filters)
                .then((response) => {
                    // console.log("getOrgSetting response=============>>", response)
                    loaderStateFalse();
                    if (response) {
                        if (response.success && response.data.length > 0) {
                            this.setState({
                                viewCheckListModal: true,
                                orgSettingDataset: response.data,
                            });
                        } else {
                            Utility.toastNotifications(
                                "No checklist found",
                                "Warning",
                                "warning"
                            );
                        }
                    }
                })
                .catch((error) => {
                    //console.error("************error*************", error)
                    loaderStateFalse();
                });
        });
        return promise;
    };

    downloadeSecreteKey = (data) => {
        //console.log("data===", data)
        let orgsecret_key = data.secret_key;
        let base64String = btoa(orgsecret_key);
        let finalBase64 = base64String;
        let orgName = data.name;
        this.downloadTextFile(finalBase64, orgName);
    };

    downloadTextFile = (finalBase64, orgName) => {
        let base64String = finalBase64;

        // Create a Blob with the Base64 string and set its type to plain text
        const blob = new Blob([base64String], { type: "text/plain" });

        // Create a URL for the Blob
        const url = URL.createObjectURL(blob);

        // Create a temporary anchor element
        const anchor = document.createElement("a");
        anchor.href = url;
        anchor.download = orgName + "-" + "secret-key.txt"; // Set the desired file name

        // Programmatically click the anchor to trigger download
        document.body.appendChild(anchor);
        anchor.click();

        // Clean up by removing the temporary anchor and revoking the Blob URL
        document.body.removeChild(anchor);
        URL.revokeObjectURL(url);
    };

    handleChangeSwitchButton = (data) => {
        // console.log('data------>', data)
        let dataHash = {};
        let id = data.id;
        dataHash["active"] = data.active ? 0 : 1;
        loaderStateTrue();
        OrganizationController.orgUpdate(id, dataHash)
            .then((response) => {
                //console.log("response=============>>", response)
                loaderStateFalse();
                if (response) {
                    if (response.success) {
                        // if (data.active) {
                        //     this.deActiveOrganisation(data);
                        // } else {
                        //     this.activeOrganisation(data);
                        //     this.createOrganisationSetting(data);
                        // }

                        this.resetDataGrid();
                        Utility.toastNotifications(response.message, "Success", "success");
                    } else {
                        this.resetDataGrid();
                        Utility.toastNotifications(response.message, "Error", "error");
                    }
                }
            })
            .catch((error) => {
                //console.error("************error*************", error)
                if (error) {
                    //Utility.toastNotifications(error.message, "Error", "error");
                }
                if (error.response.status === 406) {
                    this.resetDataGrid();
                }
                loaderStateFalse();
                if (error.message == "Network Error") {
                    // Utility.toastNotifications("Please login", "Error", "error");
                    // this.props.logOutApp().then(
                    //     () => this.props.history.push("/")
                    // );
                }
            });
    };

    createOrganisationSetting = (data) => {
        let dataHash = {};
        dataHash["org_id"] = data.id;
        loaderStateTrue();
        OrganizationController.createOrgSetting(dataHash)
            .then((response) => {
                // console.log("createOrgSetting response=============>>", response)
                loaderStateFalse();
                if (response) {
                    if (response.success) {
                    }
                }
            })
            .catch((error) => {
                //console.error("************error*************", error)
                if (error) {
                    //Utility.toastNotifications(error.message, "Error", "error");
                }
                if (error.response.status === 406) {
                    this.resetDataGrid();
                }
                loaderStateFalse();
                if (error.message == "Network Error") {
                }
            });
    };

    activeOrganisation = (data) => {
        let phoneNumberId = data.phone_number_id;
        let version = "v18.0";
        let url = `https://graph.facebook.com/${version}/${phoneNumberId}/register`;
        let accessToken = data.token;
        let headers = {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
        };
        let dataToSend = {
            messaging_product: "whatsapp",
            pin: "123456",
        };

        axios
            .post(url, dataToSend, { headers })
            .then((response) => {
                // Handle the success response
                if (response.data.success) {
                    // Utility.toastNotifications("Register in Whatsapp Message successfully", "Success", "success");
                }
            })
            .catch((error) => {
                // Handle errors
                // console.error('Error:', error);
            });
        axios
            .post(
                `https://graph.facebook.com/${version}/${data.whatsapp_business_account_id}/subscribed_apps`,
                {},
                { headers }
            )
            .then((response) => {
                // Handle the success response
                // console.log('Response:', response.data);
                if (response.data.success) {
                    // Utility.toastNotifications("Register in Whatsapp Message successfully", "Success", "success");
                }
            })
            .catch((error) => {
                // Handle errors
                console.error("Error:", error);
            });
    };

    deActiveOrganisation = (data) => {
        let phoneNumberId = data.phone_number_id;
        let version = "v18.0";
        let accessToken = data.token;
        let headers = {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
        };
        let url = `https://graph.facebook.com/${version}/${phoneNumberId}/deregister`;
        let dataToSend = {};

        axios
            .post(url, dataToSend, { headers })
            .then((response) => {
                // Handle the success response
                if (response.data.success) {
                    // Utility.toastNotifications("Deregister in Whatsapp Message successfully", "Success", "success");
                }
            })
            .catch((error) => {
                // Handle errors
                console.error("Error:", error);
            });

        axios
            .delete(
                `https://graph.facebook.com/${version}/${data.whatsapp_business_account_id}/subscribed_apps`,
                {},
                { headers }
            )
            .then((response) => {
                // Handle the success response
                if (response.data.success) {
                    // Utility.toastNotifications("Register in Whatsapp Message successfully", "Success", "success");
                }
            })
            .catch((error) => {
                // Handle errors
                console.error("Error:", error);
            });
    };

    onGridReady = (params) => {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
        this.gridparams = params;
        var datasource = this.serverSideDataSource();
        params.api.setDatasource(datasource);
    };

    serverSideDataSource = () => {
        const {
            enterpriseFilterSelectedData,
            departmentFilterSelectedData,
            statutFilterSelectedData,
            activeInActiveWorkerFilter,
            orgName,
        } = this.state;
        let that = this;
        return {
            getRows(params) {
                //console.log(JSON.stringify(params, null, 1));
                const { startRow, endRow, filterModel, sortModel } = params;
                const { loaderStateTrue, loaderStateFalse } = that.props;
                loaderStateTrue();
                let filters = {};
                let globalQueryParamshash = {};
                if (orgName != "") {
                    globalQueryParamshash["name"] = orgName;
                    filters["filter_op"] = JSON.stringify({ name: "substring" });
                }

                globalQueryParamshash["active"] = activeInActiveWorkerFilter;

                globalQueryParamshash["offset"] = startRow;
                globalQueryParamshash["limit"] = endRow;

                filters["filters"] = JSON.stringify(globalQueryParamshash);
                OrganizationController.orgListing(filters)
                    .then((response) => {
                        if (response.success) {
                            that.setState({
                                totalDatasetCount: response.total,
                            });
                            let promiseArr = [];
                            response.data.map((item, index) => {
                                let promise = new Promise((resolve, reject) => {
                                    that.logoImageUi(item.id).then((data) => {
                                        // tempUserProfileDetailsHash[item.id.toString()] = data
                                        item["profile_img_temp"] = data;

                                        // if (item.admins.length > 0) {
                                        //     item.admins.map((innerItem, index) => {
                                        //         console.log('response=================3=======>');
                                        //         let innerPromise = new Promise((resolve, reject) => {
                                        //             that.profileImageUi(innerItem.id).then((data) => {
                                        //                 console.log('response=================4=======>');
                                        //                 innerItem["user_profile_img_temp"] = data
                                        //                 resolve(item)
                                        //             })
                                        //         })
                                        //         promiseArr.push(innerPromise)
                                        //     })
                                        // }
                                        resolve(item);
                                    });
                                });
                                promiseArr.push(promise);
                            });
                            Promise.all(promiseArr).then((values) => {
                                // console.log("values==========>", values)
                                params.successCallback(values, response.total);
                            });
                            //params.successCallback(response.data, 499);
                            //that.setImageDataTemp(response.data)
                        } else {
                            console.error(error);
                            params.failCallback();
                            Utility.toastNotifications(
                                "Something went wrong !",
                                "Error",
                                "error"
                            );
                        }
                        loaderStateFalse();
                    })
                    .catch((error) => {
                        //console.error("************error*************", error)
                        if (error) {
                            //Utility.toastNotifications(error.message, "Error", "error");
                        }
                        loaderStateFalse();
                        if (error.message == "Network Error") {
                            // Utility.toastNotifications("Please login", "Error", "error");
                            // this.props.logOutApp().then(
                            //     () => this.props.history.push("/")
                            // );
                        }
                    });
            },
        };
    };

    loadGrid = () => {
        this.resetDataGrid();
    };

    resetDataGrid = () => {
        //this.gridparams.api.purgeServerSideCache(null);
        var datasource = this.serverSideDataSource();
        this.gridparams.api.setDatasource(datasource);
    };

    componentDidMount = () => {
        document.body.addEventListener(
            "mousedown",
            this.handleClickOutside.bind(this)
        );
    };
    componentWillUnmount() {
        this.setState = (state, callback) => {
            return;
        };
        if (document.body) {
            document.body.removeEventListener(
                "mousedown",
                this.handleClickOutside.bind(this)
            );
        }
    }
    handleClickOutside(event) {
        if (this.codeOutsideClickRef.current != null) {
            if (
                this.codeOutsideClickRef &&
                this.codeOutsideClickRef.current &&
                !this.codeOutsideClickRef.current.contains(event.target)
            ) {
                this.setState({
                    actionModalflag: false,
                });
            }
        }
    }

    logoImageUi = (id) => {
        const promise = new Promise((resolve, reject) => {
            const { loaderStateTrue, loaderStateFalse } = this.props;
            loaderStateTrue();
            let data = {};
            data["filters"] = JSON.stringify(Config.thumbnailSize);
            OrganizationController.orgDetails(id, data)
                .then((response) => {
                    if (response.success) {
                        //console.log("response.data[0]========", response.data[0].user_details)
                        let responseUserDetails = response.data[0].logo_img;
                        if (
                            responseUserDetails &&
                            Object.keys(responseUserDetails).length > 0
                        ) {
                            resolve(responseUserDetails.file_obj);
                        } else {
                            resolve(require("../../../Utility/Public/images/usericon.png"));
                        }
                    }
                    loaderStateFalse();
                })
                .catch((error) => {
                    //console.error("************error*************", error)
                    if (error) {
                        //Utility.toastNotifications(error.message, "Error", "error");
                    }
                    loaderStateFalse();
                    if (error.message == "Network Error") {
                        /*Utility.toastNotifications("Please login", "Error", "error");
                                this.props.logOutApp().then(
                                    () => this.props.history.push("/")
                                );*/
                    }
                });
        });
        return promise;
    };

    profileImageUi = (id) => {
        const promise = new Promise((resolve, reject) => {
            const { loaderStateTrue, loaderStateFalse } = this.props;
            loaderStateTrue();
            let data = {};
            data["filters"] = JSON.stringify(Config.thumbnailSize);
            OrganizationController.userDetails(id, data)
                .then((response) => {
                    if (response.success) {
                        let responseUserDetails = response.data[0].profile_img;
                        if (
                            responseUserDetails &&
                            Object.keys(responseUserDetails).length > 0
                        ) {
                            resolve(responseUserDetails.file_obj);
                        } else {
                            resolve(require("../../../Utility/Public/images/usericon.png"));
                        }
                    }
                    loaderStateFalse();
                })
                .catch((error) => {
                    //console.error("************error*************", error)
                    if (error) {
                        //Utility.toastNotifications(error.message, "Error", "error");
                    }
                    loaderStateFalse();
                    if (error.message == "Network Error") {
                        /*Utility.toastNotifications("Please login", "Error", "error");
                                this.props.logOutApp().then(
                                    () => this.props.history.push("/")
                                );*/
                    }
                });
        });
        return promise;
    };

    closeOrganizationModal = () => {
        const { t } = this.props;
        this.setState(
            {
                organizationModal: false,
                zoominzoomoutflag: "",
            },
            () => {
                //console.log("organizationModal close", this.state.organizationModal)
                this.resetOrganizationFrom();
            }
        );
    };

    //Image url crop
    addInputProfileImageChanged = (event) => {
        let { fromData } = this.state;
        let targetFileSplit = event.target.files[0].name.split(".");
        let lastElement = targetFileSplit.pop();
        let user_profile_image = {
            file_name: "",
            file_obj: "",
        };
        if (
            lastElement == "JPEG" ||
            lastElement == "jpeg" ||
            lastElement == "jpg" ||
            lastElement == "JPG" ||
            lastElement == "png" ||
            lastElement == "PNG" ||
            lastElement == ""
        ) {
            const fsize = event.target.files[0].size;
            const file = Math.round(fsize / 1024);
            if (file >= 300) {
                Utility.toastNotifications(
                    "File is too Big, please select a file less than 300kb",
                    "Warning",
                    "warning"
                );
            } else {
                this.setState({
                    imageCropModalFlag: true,
                });
                if (event.target.files && event.target.files.length > 0) {
                    const reader = new FileReader();
                    reader.addEventListener("load", () =>
                        this.setState({ src: reader.result })
                    );
                    reader.readAsDataURL(event.target.files[0]);
                    user_profile_image["file_name"] = event.target.files[0].name;
                    user_profile_image["file_obj"] = "";
                    fromData["profileImage"] = user_profile_image;
                    this.setState({
                        fromData,
                        addProfileImagePreviewShow: true,
                        addProfileImageError: "",
                        //orgDataEditFlag: true,
                        imageEditFrom: "org",
                    });
                }
            }
        } else {
            fromData["profileImage"] = "";
            this.setState({
                fromData,
                addProfileImagePreviewShow: false,
                addprofileImageSelected: "Add Image",
                //orgDataEditFlag: true,
            });
        }
    };

    onImageLoaded = (image) => {
        //console.log("onImageLoaded=====", image)
        this.imageRef = image;
    };

    onCropChange = (crop, percentCrop) => {
        // You could also use percentCrop:
        // this.setState({ crop: percentCrop });
        this.setState({ crop });
    };

    onCropComplete = (crop) => {
        this.makeClientCrop(crop, "forOrgImage");
        this.setState({
            //saveButtonDisableEditModal: false
        });
    };

    onCropCompleteForUser = (crop) => {
        this.makeClientCrop(crop, "forUserImage");
        this.setState({
            //saveButtonDisableEditModal: false
        });
    };

    async makeClientCrop(crop, callFrom) {
        const { fromData, addUserFromData } = this.state;
        if (this.imageRef && crop.width && crop.height) {
            const croppedImageUrl = await this.getCroppedImg(
                this.imageRef,
                crop,
                "newFile.jpeg"
            );
            let org_image = {};
            let add_user_image = {};
            if (callFrom == "forOrgImage") {
                this.setState({
                    addprofileImageSelected: croppedImageUrl,
                });
                // for org image
                org_image["file_name"] = this.state.fromData.profileImage.file_name;
                org_image["file_obj"] = this.state.addprofileImageSelected;
                fromData["profileImage"] = org_image;
            } else {
                this.setState({
                    addUserImageSelected: croppedImageUrl,
                });
                // for user image
                add_user_image[
                    "file_name"
                ] = this.state.addUserFromData.profileImage.file_name;
                add_user_image["file_obj"] = this.state.addUserImageSelected;
                addUserFromData["profileImage"] = add_user_image;
            }
            this.setState({
                fromData,
                addUserFromData,
            });
        }
    }

    getCroppedImg = (image, crop, fileName) => {
        const canvas = document.createElement("canvas");
        const pixelRatio = window.devicePixelRatio;
        const scaleX = image.naturalWidth / image.width;
        const scaleY = image.naturalHeight / image.height;
        const ctx = canvas.getContext("2d");

        canvas.width = crop.width * pixelRatio * scaleX;
        canvas.height = crop.height * pixelRatio * scaleY;

        ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
        ctx.imageSmoothingQuality = "high";

        ctx.drawImage(
            image,
            crop.x * scaleX,
            crop.y * scaleY,
            crop.width * scaleX,
            crop.height * scaleY,
            0,
            0,
            crop.width * scaleX,
            crop.height * scaleY
        );

        const base64Image = canvas.toDataURL("image/jpeg");
        return base64Image;
    };

    //Image url crop

    imageCropModalShow = () => {
        this.setState({
            imageCropModalFlag: true,
        });
    };

    imageCropModalHide = () => {
        const { fromData, addUserFromData } = this.state;
        fromData["profileImage"] = "";
        addUserFromData["profileImage"] = "";
        this.setState({
            imageCropModalFlag: false,

            // for org image
            addprofileImageSelected: require("../../../Utility/Public/images/profile-back.png"),
            addProfileImageError: "",
            fromData,
            addProfileImagePreviewShow: false,

            // for user image
            addUserImageSelected: require("../../../Utility/Public/images/profile-back.png"),
            addUserImageError: "",
            addUserFromData,
            addUserImagePreviewShow: false,
            //saveButtonDisableEditModal: true
        });
    };

    imageCropDataSave = () => {
        this.setState({
            imageCropModalFlag: false,
        });
    };

    handleUserSearchBar = (e) => {
        this.setState(
            {
                orgName: e.target.value,
            },
            () => {
                if (this.state.orgName.length > 2) {
                    this.resetDataGrid();
                }
                if (this.state.orgName == "") {
                    this.resetDataGrid();
                }
            }
        );
    };

    clearSearchValue = () => {
        this.setState(
            {
                orgName: "",
            },
            () => {
                this.resetDataGrid();
            }
        );
    };

    organizationModalfunction = () => {
        this.setState(
            {
                organizationModal: true,
                orgAddEditModalTitle: "Add Organization",
            },
            () => {
                //console.log("organizationModal add", this.state.organizationModal)
            }
        );
        //alert()
    };

    handelChange = (event, type) => {
        let fromDataTemp = Object.assign({}, this.state.fromData);
        let fromDataTempError = Object.assign({}, this.state.fromDataError);
        if (type == "organization_name") {
            var expr = /^[a-zA-Z0-9. ]*$/;
            if (!expr.test(event.target.value)) {
                // fromDataTempError['organization_name'] = "Only allow characters"
            } else {
                if (event.target.value != "") {
                    fromDataTemp["organization_name"] = event.target.value;
                    fromDataTempError["organization_name"] = "";
                } else {
                    fromDataTemp["organization_name"] = "";
                    //fromDataTempError['organization_name'] = "Required field"
                }
            }
        }

        if (type == "user_count") {
            var expr = /^[0-9]*$/;
            if (!expr.test(event.target.value)) {
            } else {
                if (event.target.value != "") {
                    fromDataTemp["user_count"] = event.target.value;
                    fromDataTempError["user_count"] = "";
                } else {
                    fromDataTemp["user_count"] = "";
                }
            }
        }

        if (type == "whatsapp_api_endpoint") {
            if (event.target.value != "") {
                fromDataTemp["whatsapp_api_endpoint"] = event.target.value;
                fromDataTempError["whatsapp_api_endpoint"] = "";
            } else {
                fromDataTemp["whatsapp_api_endpoint"] = "";
                //fromDataTempError['whatsapp_api_endpoint'] = "Required field"
            }
        }
        if (type == "delay_time") {
            if (event.target.value != "") {
                fromDataTemp["delay_time"] = event.target.value;
                fromDataTempError["delay_time"] = "";
            } else {
                fromDataTemp["delay_time"] = "";
                //fromDataTempError['delay_time'] = "Required field"
            }
        }
        if (type == "phone_number_id") {
            if (event.target.value != "") {
                fromDataTemp["phone_number_id"] = event.target.value;
                fromDataTempError["phone_number_id"] = "";
            } else {
                fromDataTemp["phone_number_id"] = "";
                //fromDataTempError['phone_number_id'] = "Required field"
            }
        }
        if (type == "token") {
            if (event.target.value != "") {
                fromDataTemp["token"] = event.target.value;
                fromDataTempError["token"] = "";
            } else {
                fromDataTemp["token"] = "";
                // fromDataTempError['token'] = "Required field"
            }
        }
        if (type == "marketed_by_name") {
            if (event.target.value != "") {
                fromDataTemp["marketed_by_name"] = event.target.value;
                fromDataTempError["marketed_by_name"] = "";
            } else {
                fromDataTemp["marketed_by_name"] = "";
                //fromDataTempError['marketed_by_name'] = "Required field"
            }
        }
        if (type == "marketed_by_url") {
            if (event.target.value != "") {
                fromDataTemp["marketed_by_url"] = event.target.value;
                fromDataTempError["marketed_by_url"] = "";
            } else {
                fromDataTemp["marketed_by_url"] = "";
                //fromDataTempError['marketed_by_url'] = "Required field"
            }
        }

        if (type == "facebook_app_id") {
            if (event.target.value != "") {
                fromDataTemp["facebook_app_id"] = event.target.value;
                fromDataTempError["facebook_app_id"] = "";
            } else {
                fromDataTemp["facebook_app_id"] = "";
                //fromDataTempError['facebook_app_id'] = "Required field"
            }
        }

        if (type == "whatsapp_business_account_id") {
            if (event.target.value != "") {
                fromDataTemp["whatsapp_business_account_id"] = event.target.value;
                fromDataTempError["whatsapp_business_account_id"] = "";
            } else {
                fromDataTemp["whatsapp_business_account_id"] = "";
                //fromDataTempError['whatsapp_business_account_id'] = "Required field"
            }
        }

        if (type == "is_mfa_required") {
            if (event) {
                fromDataTemp["is_mfa_required"] = event.target.checked;
                fromDataTempError["is_mfa_required"] = "";
            } else {
                fromDataTemp["is_mfa_required"] = false;
                fromDataTempError["is_mfa_required"] = "";
            }
        }

        if (type === "marketing_message") {
            var expr = /^[0-9]*$/;
            if (!expr.test(event.target.value)) {
            } else {
                if (event.target.value != "") {
                    fromDataTemp["marketing_message"] = event.target.value;
                    fromDataTempError["marketing_message"] = "";
                } else {
                    fromDataTemp["marketing_message"] = "";
                }
            }
        }

        // checking for number only

        if (type == "utility_message") {
            var expr = /^[0-9]*$/;
            if (!expr.test(event.target.value)) {
            } else {
                if (event.target.value != "") {
                    fromDataTemp["utility_message"] = event.target.value;
                    fromDataTempError["utility_message"] = "";
                } else {
                    fromDataTemp["utility_message"] = "";
                }
            }
        }

        this.setState(
            {
                fromData: fromDataTemp,
                fromDataError: fromDataTempError,
                //orgDataEditFlag: true,
                //saveButtonDisableEditModal: false
            },
            () => {
                //console.log("fromData=========", this.state.fromData)
            }
        );
    };

    formatingFormData = () => {
        const {
            fromData,
            documentObjfileObj,
            whatsappBusinessPhoneNumber,
            yearlySubscription,
            monthlySubscription,
        } = this.state;

        let dataSet = [];
        let hash = {};

        hash["name"] = fromData.organization_name;
        hash["delay_time"] = fromData.delay_time;
        hash["whatsapp_api_endpoint"] = fromData.whatsapp_api_endpoint;
        hash["phone_number_id"] = fromData.phone_number_id;
        hash["token"] = fromData.token;
        hash["marketed_by_name"] = fromData.marketed_by_name;
        hash["marketed_by_url"] = fromData.marketed_by_url;
        hash["whatsapp_business_phone_number"] = whatsappBusinessPhoneNumber;

        hash["subscription_type"] =
            yearlySubscription === true
                ? "yearly"
                : monthlySubscription
                    ? "monthly"
                    : "freetrial";

        hash["contract_start_date"] = `${fromData.contractStartDate.year
            }-${fromData.contractStartDate.month
                .toString()
                .padStart(2, 0)}-${fromData.contractStartDate.day
                    .toString()
                    .padStart(2, 0)}`;

        hash["contract_end_date"] = `${fromData.contractEndDate.year
            }-${fromData.contractEndDate.month
                .toString()
                .padStart(2, 0)}-${fromData.contractEndDate.day
                    .toString()
                    .padStart(2, 0)}`;

        if (fromData.org_id !== "") {
            hash["user_count"] = Number(fromData.user_count);
            hash["unsubscribe_keys"] =
                this.state.tagsValue.length > 0
                    ? this.state.tagsValue
                        .map((e) => e.value)
                        .filter((v) => v && v.trim() !== "")
                        .join(",")
                    : "";
        }

        let versionList = this.props.version;
        let selectedVersion = versionList.filter(
            (e) => e.label === fromData.selectedVersion?.[0]?.label
        );

        const versionLabel = selectedVersion?.[0]?.label;
        const isFundedByMettleTech =
            versionLabel === "V6" ? true : this.state.isCheckboxChecked;
        const showMessageFields = isFundedByMettleTech;

        hash["version_id"] = selectedVersion?.[0]?.value;
        hash["facebook_app_id"] = fromData.facebook_app_id;
        hash["whatsapp_business_account_id"] =
            fromData.whatsapp_business_account_id;
        hash["is_mfa_required"] = fromData?.is_mfa_required;

        // mt_credit and message counts logic (final and fixed)
        hash["mt_credit"] = isFundedByMettleTech ? 1 : 0;

        if (
            showMessageFields &&
            fromData.marketing_message != null &&
            fromData.marketing_message.toString().trim() !== ""
        ) {
            hash["marketing_message"] = fromData.marketing_message.toString().trim();
        } else {
            delete hash["marketing_message"];
        }

        if (
            showMessageFields &&
            fromData.utility_message != null &&
            fromData.utility_message.toString().trim() !== ""
        ) {
            hash["utility_message"] = fromData.utility_message.toString().trim();
        } else {
            delete hash["utility_message"];
        }

        if (Object.keys(fromData.profileImage || {}).length > 0) {
            hash["logo_url"] = fromData.profileImage;
        }

        if (Object.keys(documentObjfileObj || {}).length > 0) {
            hash["marketed_by_logo_url"] = documentObjfileObj;
        }

        hash["id"] = fromData.id;

        dataSet.push(hash);
        return dataSet;
    };

    addCustomer = () => {
        const { orgDataEditFlag, userDataEditFlag } = this.state;
        // console.log('orgDataEditFlag---------------->',orgDataEditFlag)
        // if (orgDataEditFlag) {
        this.addEditOrganizationData();
        // }
        if (userDataEditFlag) {
            this.addEditUser();
        }
    };

    addEditOrganizationData = () => {
        let valid = this.validCustomerData();
        // console.log('Edit-----Edit-------->')
        // console.log('valid------------->', valid)
        if (valid) {
            let dataSet = this.formatingFormData();

            console.log("🔎 Payload being sent:", JSON.stringify(dataSet, null, 2));
            const { loaderStateTrue, loaderStateFalse } = this.props;
            const { fromData } = this.state;

            loaderStateTrue();

            let type = "post";
            let id = "";
            if (fromData.org_id != "") {
                (id = fromData.org_id), (type = "patch");
                dataSet = dataSet[0];
            }
            // console.log("dataSet=========",dataSet)
            // return false;
            OrganizationController.orgCreate(dataSet, id, type)
                .then((response) => {
                    //console.log("response=====", response)
                    loaderStateFalse();

                    if (type == "post") {
                        if (response.length > 0) {
                            response.map((res, index) => {
                                if (res.success) {
                                    this.closeOrganizationModal();
                                    this.resetDataGrid();
                                    Utility.toastNotifications(res.message, "Success", "success");
                                } else {
                                    Utility.toastNotifications(res.message, "Error", "error");
                                }
                            });
                        }
                    } else {
                        if (response.success) {
                            //alert("addEditOrganizationData patch")
                            this.closeOrganizationModal();
                            this.resetDataGrid();
                            Utility.toastNotifications(
                                response.message,
                                "Success",
                                "success"
                            );
                        } else {
                            Utility.toastNotifications(response.message, "Error", "error");
                        }
                    }
                    // this.setState({
                    //     documentObjfileObj: "",
                    //     documentObjFileName: this.props.t('choosefile'),

                    // })
                })
                .catch((error) => {
                    console.error("************error*************", error);
                    if (error) {
                        //Utility.toastNotifications(error.message, "Error", "error");
                    }
                    loaderStateFalse();
                    if (error.message == "Network Error") {
                        // Utility.toastNotifications("Please login", "Error", "error");
                        // this.props.logOutApp().then(
                        //     () => this.props.history.push("/")
                        // );
                    }
                });
        }
    };

    validCustomerData = () => {
        let fromDataTemp = Object.assign({}, this.state.fromData);
        let fromDataTempError = Object.assign({}, this.state.fromDataError);
        let valid = true;

        if (fromDataTemp.organization_name == "") {
            fromDataTempError["organization_name"] = "Required field";
            valid = false;
        } else {
            fromDataTempError["organization_name"] = "";
        }

        if (fromDataTemp.whatsapp_api_endpoint == "") {
            fromDataTempError["whatsapp_api_endpoint"] = "Required field";
            valid = false;
        } else {
            fromDataTempError["whatsapp_api_endpoint"] = "";
        }

        if (fromDataTemp.phone_number_id == "") {
            fromDataTempError["phone_number_id"] = "Required field";
            valid = false;
        } else {
            fromDataTempError["phone_number_id"] = "";
        }

        if (fromDataTemp.delay_time == "") {
            fromDataTempError["delay_time"] = "Required field";
            valid = false;
        } else {
            fromDataTempError["delay_time"] = "";
        }

        if (fromDataTemp.token == "") {
            fromDataTempError["token"] = "Required field";
            valid = false;
        } else {
            fromDataTempError["token"] = "";
        }
        if (fromDataTemp.selectedVersion.length == 0) {
            fromDataTempError["selectedVersion"] = "Required field";
            valid = false;
        } else {
            fromDataTempError["selectedVersion"] = "";
        }
        if (fromDataTemp.contractStartDate == "") {
            fromDataTempError["contractStartDate"] = "Required field";
            valid = false;
        } else {
            fromDataTempError["contractStartDate"] = "";
        }
        if (fromDataTemp.contractEndDate == "") {
            fromDataTempError["contractEndDate"] = "Required field";
            valid = false;
        } else {
            fromDataTempError["contractEndDate"] = "";
        }
        if (this.state.fromData.org_id != "") {
            if (fromDataTemp.user_count == "") {
                fromDataTempError["user_count"] = "Required field";
                valid = false;
            } else if (
                fromDataTemp.user_count !== "" &&
                Number(fromDataTemp.user_count) == 0
            ) {
                fromDataTempError["user_count"] = "User count must be greater than 0";
                valid = false;
            } else {
                fromDataTempError["user_count"] = "";
            }
        }
        if (this.state.whatsappBusinessPhoneNumber == "") {
            this.setState({
                whatsappBusinessPhoneNumberError: "Required field",
            });
            valid = false;
        } else {
            // console.log("this.state.phoneNumber--------------//////------->",this.state.phoneNumber)
            let phoneNumberValidCheck = HomeUtility.validate_Phone_Number_without_plus(
                Config.phoneNumberWithOrwithoutPlus +
                this.state.whatsappBusinessPhoneNumber
            );
            // console.log("phoneNumberValidCheck-------------->", phoneNumberValidCheck)
            if (phoneNumberValidCheck) {
                this.setState({
                    whatsappBusinessPhoneNumberError: "",
                });
            } else {
                this.setState({
                    whatsappBusinessPhoneNumberError: "Enter valid phone number",
                });
                valid = false;
            }
        }

        if (fromDataTemp.facebook_app_id == "") {
            fromDataTempError["facebook_app_id"] = "Required field";
            valid = false;
        } else {
            fromDataTempError["facebook_app_id"] = "";
        }

        if (fromDataTemp.whatsapp_business_account_id == "") {
            fromDataTempError["whatsapp_business_account_id"] = "Required field";
            valid = false;
        } else {
            fromDataTempError["whatsapp_business_account_id"] = "";
        }

        this.setState({
            fromDataError: fromDataTempError,
        });
        return valid;
    };

    resetOrganizationFrom = () => {
        this.setState({
            fromData: {
                organization_name: "",
                profileImage: "",
                org_id: "",
                whatsapp_api_endpoint: "",
                phone_number_id: "",
                token: "",
                marketed_by_name: "",
                marketed_by_url: "",
                selectedVersion: [],
                contractStartDate: "",
                contractEndDate: "",
                facebook_app_id: "",
                whatsapp_business_account_id: "",
                delay_time: "0.00",
                is_mfa_required: false,
                user_count: "",
            },
            fromDataError: {
                organization_name: "",
                whatsapp_api_endpoint: "",
                phone_number_id: "",
                token: "",
                marketed_by_name: "",
                marketed_by_url: "",
                selectedVersion: "",
                contractStartDate: "",
                contractEndDate: "",
                facebook_app_id: "",
                whatsapp_business_account_id: "",
                delay_time: "",
                is_mfa_required: false,
                user_count: "",
            },
            //orgDataEditFlag: false,
            imageEditFrom: "",

            addUserFromData: {
                name: "",
                email: "",
                //"phone": "",
                //"address": "",
                profileImage: "",
                status: true,
                user_id: "",
            },
            /*addUserInfoFromData: {
                      "city": "",
                      "country": "",
                      "phone_no": "",
                  },*/
            addUserFromDataError: {
                name: "",
                email: "",
            },
            addUserInfoFromDataError: {
                city: "",
                country: "",
                phone_no: "",
            },
            addprofileImageSelected: require("../../../Utility/Public/images/uploadicon.png"),
            addProfileImagePreviewShow: false,
            //saveButtonDisableEditModal: true,

            documentObjFileName: this.props.t("choosefile"),
            documentObjfileObj: "",
            documentError: "",
            handleChangeVersionFlag: false,
            freeTrialSubscription: false,
            monthlySubscription: false,
            yearlySubscription: false,
            whatsappBusinessPhoneNumberError: "",
            whatsappBusinessPhoneNumber: "",
            whatsappBusinessPhoneNumberNote: false,
            tagsValue: [],
            tagsOptions: [],
        });
    };

    actionModalfunction = (gridObj, e) => {
        let width = "";
        if (localStorage.getItem("selected_lan_direction") == "rtl") {
            width = parseInt(e.clientX) + 40 + "px";
        } else {
            width = parseInt(e.clientX) - 280 + "px";
        }
        let height = parseInt(e.clientY) - 70 + "px";
        //console.log("gridObj", gridObj)
        this.setState(
            {
                actionModalflag: true,
                overlayHight: height,
                overlayWidth: width,
                gridObjData: gridObj,
            },
            () => {
                // if (this.state.gridObjData.data.admins.length > 0) {
                this.setState({
                    deleteButtonEnableFlagForGridActionContent: true,
                });
                // } else {
                //     this.setState({
                //         deleteButtonEnableFlagForGridActionContent: false
                //     })
                // }
                this.setEditData();
            }
        );
    };

    setEditData = () => {
        //console.log("setEditData===========")

        const { gridObjData, addUserFromData, addUserInfoFromData } = this.state;
        let addUserFromDataTemp = Object.assign({}, addUserFromData);
        let addUserInfoFromDataTemp = Object.assign({}, addUserInfoFromData);
        // console.log("gridObjData===========", gridObjData)
        //let marketedLogo = JSON.parse(gridObjData?.data?.marketed_by_logo_url)?.file_name

        let marketedLogo =
            gridObjData.data.marketed_by_logo_url != null &&
                JSON.parse(gridObjData.data.marketed_by_logo_url).hasOwnProperty(
                    "file_name"
                )
                ? JSON.parse(gridObjData?.data?.marketed_by_logo_url)?.file_name
                : this.props.t("choosefile");

        let version =
            gridObjData.data.version_id != null ? gridObjData.data.version_id : "";
        let tempOptionData = this.state.versionOption.slice();
        let objectWithKeyA = this.findObjectByKey(tempOptionData, "value", version);
        //console.log("tempOptionData==========", tempOptionData)
        //console.log("objectWithKeyA==========", objectWithKeyA)
        let selectedVerionArray = [];
        if (objectWithKeyA != null) {
            selectedVerionArray.push(objectWithKeyA);
        } else {
            this.setState({ selectedVersion: selectedVerionArray }, () => { });
        }

        var formattedStartContractDate = "";
        if (
            gridObjData.data.hasOwnProperty("contract_start_date") &&
            gridObjData.data.contract_start_date != "" &&
            gridObjData.data.contract_start_date != null
        ) {
            let tempcontract_start_date = new Date(
                gridObjData.data.contract_start_date
            );
            formattedStartContractDate = {
                year: tempcontract_start_date.getFullYear(),
                month: tempcontract_start_date.getMonth() + 1,
                day: tempcontract_start_date.getDate(),
            };
        }

        var formattedEndContractDate = "";
        if (
            gridObjData.data.hasOwnProperty("contract_end_date") &&
            gridObjData.data.contract_end_date != "" &&
            gridObjData.data.contract_end_date != null
        ) {
            let tempcontract_end_date = new Date(gridObjData.data.contract_end_date);
            formattedEndContractDate = {
                year: tempcontract_end_date.getFullYear(),
                month: tempcontract_end_date.getMonth() + 1,
                day: tempcontract_end_date.getDate(),
            };
        }

        let unsubscribeKeys = [];
        if (
            gridObjData.data.hasOwnProperty("unsubscribe_keys") &&
            gridObjData.data.unsubscribe_keys &&
            typeof gridObjData.data.unsubscribe_keys == "string"
        ) {
            unsubscribeKeys = gridObjData.data.unsubscribe_keys
                .split(",")
                .filter((item) => item && item.trim() !== "")
                .map((item) => ({
                    label: item,
                    value: item,
                }));
        }

        this.setState(
            {
                fromData: {
                    organization_name: gridObjData.data.name,
                    whatsapp_api_endpoint: gridObjData.data.whatsapp_api_endpoint,
                    phone_number_id: gridObjData.data.phone_number_id,
                    token: gridObjData.data.token,
                    marketed_by_name: gridObjData.data.marketed_by_name,
                    marketed_by_url: gridObjData.data.marketed_by_url,
                    profileImage: "",
                    org_id: gridObjData.data.id,
                    selectedVersion: selectedVerionArray,
                    contractStartDate: formattedStartContractDate,
                    contractEndDate: formattedEndContractDate,
                    facebook_app_id: gridObjData.data.facebook_app_id,
                    whatsapp_business_account_id:
                        gridObjData.data.whatsapp_business_account_id,
                    delay_time: gridObjData.data.delay_time,
                    is_mfa_required:
                        gridObjData.data.hasOwnProperty("is_mfa_required") &&
                            gridObjData.data.is_mfa_required != null
                            ? gridObjData.data.is_mfa_required == true
                                ? true
                                : false
                            : false,
                    user_count:
                        gridObjData.data.user_count != null
                            ? gridObjData.data.user_count.toString()
                            : "",
                },
                tagsOptions: unsubscribeKeys,
                tagsValue: unsubscribeKeys,
                addProfileImagePreviewShow: true,
                addprofileImageSelected: gridObjData.data.profile_img_temp,
                //documentObjFileName: JSON.parse(gridObjData.data.marketed_by_logo_url).file_name
                documentObjFileName: marketedLogo,
                whatsappBusinessPhoneNumber:
                    gridObjData.data.whatsapp_business_phone_number,
                isCheckboxChecked: gridObjData.data.mt_credit && gridObjData.data.mt_credit == 1 ? true : false,
                showMessageCountFields: gridObjData.data.mt_credit && gridObjData.data.mt_credit == 1 ? true : false,
            },
            () => {
                this.setSubscriptionValue();
                //console.log("documentObjFileName===========", this.documentObjFileName)
                // if (gridObjData.data.admins.length > 0) {
                //     addUserFromDataTemp = {
                //         "name": gridObjData.data.admins[0].user_name,
                //         "email": gridObjData.data.admins[0].user_email,
                //         //"phone": gridObjData.data.admins[0].user_ph_no,
                //         //"address": gridObjData.data.admins[0].address,
                //         "profileImage": "",
                //         "status": gridObjData.data.admins[0].status,
                //         "user_id": gridObjData.data.admins[0].id,
                //     }

                //     addUserInfoFromDataTemp = {
                //         "city": gridObjData?.data?.admins[0]?.personal_information?.city,
                //         "country": gridObjData?.data?.admins[0]?.personal_information?.country,
                //         "phone_no": gridObjData?.data?.admins[0]?.personal_information?.phone_no,
                //     },

                //         this.setState({
                //             addUserFromData: addUserFromDataTemp,
                //             addUserImagePreviewShow: true,
                //             addUserImageSelected: gridObjData.data.admins[0].user_profile_img_temp,
                //             addUserInfoFromData: addUserInfoFromDataTemp
                //         }, () => {
                //             //console.log("addUserInfoFromData================1", this.state.addUserInfoFromData)
                //         })
                // } else {
                addUserFromDataTemp = {
                    name: "",
                    email: "",
                    //"phone": "",
                    //"address": "",
                    profileImage: "",
                    status: "",
                    user_id: "",
                };
                (addUserInfoFromDataTemp = {
                    city: "",
                    country: "",
                    phone_no: "",
                }),
                    this.setState(
                        {
                            addUserFromData: addUserFromDataTemp,
                            addUserImagePreviewShow: false,
                            addUserImageSelected: "",
                            addUserInfoFromData: addUserInfoFromDataTemp,
                        },
                        () => {
                            //console.log("addUserImageSelected", this.state.addUserImageSelected)
                        }
                    );
                // }
            }
        );
    };

    setSubscriptionValue = () => {
        const { gridObjData } = this.state;
        // const diff = Utility.checkDateDiff(fromData.contractStartDate, fromData.contractEndDate)
        let subsType = gridObjData?.data?.subscription_type;
        if (subsType == "yearly") {
            this.setState({
                yearlySubscription: true,
                monthlySubscription: false,
                freeTrialSubscription: false,
            });
        } else if (subsType == "monthly") {
            this.setState({
                yearlySubscription: false,
                monthlySubscription: true,
                freeTrialSubscription: false,
            });
        } else {
            this.setState({
                yearlySubscription: false,
                monthlySubscription: false,
                freeTrialSubscription: true,
            });
        }
    };

    findObjectByKey = (array, key, value) => {
        for (let i = 0; i < array.length; i++) {
            if (array[i][key] === value) {
                return array[i];
            }
        }
        return null; // Object not found
    };
    editOrganization = (params) => {
        //console.log("params",params)
        this.getPhoneNumberActivateStatus(params); // imtiaj
        this.setState(
            {
                organizationModal: true,
                orgAddEditModalTitle: "Edit Organization",
                //saveButtonDisableEditModal: true,
                userDataEditFlag: true,
            },
            () => {
                //console.log("organizationModal edit", this.state.organizationModal)
                this.getUtilityMessageApi(params);
                this.getCallChangeCatelog();
            }
        );
    };
    getUtilityMessageApi = (params) => {
        let id = params.data.id;
        console.log("id is", id);

        OrganizationController.getUserMessageBalances(id)
            .then((response) => {
                loaderStateFalse();

                if (response && response.success) {
                    const utilityBalance = response.data?.utility_message_balance;
                    const marketingBalance = response.data?.marketing_message_balance;

                    console.log("Utility Balance:", utilityBalance);
                    console.log("Marketing Balance:", marketingBalance);
                    this.setState((prevState) => ({
                        fromData: {
                            ...prevState.fromData,
                            balance_utility_message: utilityBalance,
                            balance_marketing_message: marketingBalance,
                        },
                    }));

                } else {

                    // console.warn("Failed to fetch message balances");
                }
            })
            .catch((error) => {
                if (error.response?.status === 406) {
                    this.resetDataGrid();
                }
                loaderStateFalse();

                if (error.message === "Network Error") {

                }
            });
    };



    getPhoneNumberActivateStatus = (params) => {
        //imtiaj //logoImageUi
        let dataHash = {};
        let filters = {};
        dataHash["org_id"] = params.data.id;
        filters["filters"] = JSON.stringify(dataHash);
        loaderStateTrue();
        const promise = new Promise((resolve, reject) => {
            //const { loaderStateTrue, loaderStateFalse } = this.props;
            //loaderStateTrue();
            OrganizationController.getPhoneNumberActivateStatus(filters)
                .then((response) => {
                    if (response.success) {
                        this.setState({
                            disableActivePhnnoButton:
                                response.data.whatsapp_phone_number_activated,
                        });
                    }
                    //loaderStateFalse();
                })
                .catch((error) => {
                    if (error) {
                    }
                    loaderStateFalse();
                    if (error.message == "Network Error") {
                    }
                });
        });
        return promise;
    };

    deleteOrganization = (params) => {
        this.setState({
            deleteConfirmationAlertModal: true,
            actionModalflag: false,
            orgDeleteBodySecondContent: params.data.name,
            organizationDeleteObj: params.data,
        });
    };

    deleteConfirmationModalHide = () => {
        this.setState({
            deleteConfirmationAlertModal: false,
            orgDeleteBodySecondContent: "",
        });
    };

    orgDeleteConfirmButton = () => {
        this.oranizationDeleteApi();
    };

    orgDeleteCancleButton = () => {
        this.deleteConfirmationModalHide();
    };

    oranizationDeleteApi = () => {
        const { organizationDeleteObj } = this.state;
        //console.log("organizationDeleteObj",organizationDeleteObj)

        const { loaderStateTrue, loaderStateFalse } = this.props;
        loaderStateTrue();
        let data = {};
        data["id"] = [organizationDeleteObj.id];

        OrganizationController.organizationDelete(data)
            .then((response) => {
                if (response.success) {
                    this.resetDataGrid();
                    this.deleteConfirmationModalHide();
                    this.resetOrganizationFrom();
                    Utility.toastNotifications(
                        response.data[0].message,
                        "Success",
                        "success"
                    );
                } else {
                    Utility.toastNotifications(
                        response.data[0].message,
                        "Error",
                        "error"
                    );
                }
                loaderStateFalse();
            })
            .catch((error) => {
                console.error("************error*************", error);
                if (error) {
                    //Utility.toastNotifications(error.message, "Error", "error");
                }
                loaderStateFalse();
                if (error.message == "Network Error") {
                }
            });
    };

    addUserShow = () => {
        this.setState({
            addUserModalFlag: true,
            addUserImagePreviewShow: false,
            addUserImageSelected: require("../../../Utility/Public/images/profile-back.png"),
            addUserFromData: {
                name: "",
                email: "",
                //"phone": "",
                //"address": "",
                profileImage: "",
                status: true,
                user_id: "",
            },
            addUserInfoFromData: {
                city: "",
                country: "",
                phone_no: "",
            },
            addUserFromDataError: {
                name: "",
                email: "",
            },
            addUserInfoFromDataError: {
                city: "",
                country: "",
                phone_no: "",
            },
        });
    };
    closeUserModal = () => {
        this.setState(
            {
                addUserModalFlag: false,
            },
            () => {
                this.cancelAddUserData();
            }
        );
    };

    addUserFromDataChange = (event, type) => {
        const { addUserFromData, addUserFromDataError } = this.state;
        let tempAddUserFromData = Object.assign({}, addUserFromData);
        let tempAddUserFromDataError = Object.assign({}, addUserFromDataError);

        if (type == "name") {
            if (event.target.value != "") {
                tempAddUserFromData["name"] = event.target.value;
                tempAddUserFromDataError["name"] = "";
            } else {
                tempAddUserFromData["name"] = "";
                tempAddUserFromDataError["name"] = "Required field";
            }
        }

        if (type == "email") {
            if (event.target.value != "") {
                tempAddUserFromData["email"] = event.target.value;
                tempAddUserFromDataError["email"] = "";
            } else {
                tempAddUserFromData["email"] = "";
                tempAddUserFromDataError["email"] = "Required field";
            }
        }

        /*if (type == "phone") {
                if (event.target.value != "") {
                    let phoneValidate = HomeUtility.validate_Phone_Number(event.target.value);
                    if (phoneValidate) {
                        tempAddUserFromData['phone'] = event.target.value;
                        tempAddUserFromDataError['phone'] = ""
                    } else {
                        tempAddUserFromData['phone'] = event.target.value;
                        tempAddUserFromDataError['phone'] = this.props.t('validphonenumber')
                    }
                } else {
                    tempAddUserFromData['phone'] = "";
                    tempAddUserFromDataError['phone'] = ""
                }
            }
    
            if (type == "address") {
                if (event.target.value != "") {
                    tempAddUserFromData['address'] = event.target.value;
                    tempAddUserFromDataError['address'] = ""
                } else {
                    tempAddUserFromData['address'] = "";
                    tempAddUserFromDataError['address'] = ""
                }
            }*/

        if (type == "status") {
            if (event.target.checked) {
                tempAddUserFromData["status"] = true;
                tempAddUserFromDataError["status"] = "";
            } else {
                tempAddUserFromData["status"] = false;
                tempAddUserFromDataError["status"] = "";
            }
        }

        this.setState({
            addUserFromData: tempAddUserFromData,
            addUserFromDataError: tempAddUserFromDataError,
            userDataEditFlag: true,
            //saveButtonDisableEditModal: false,
        });
    };

    addUserInfoFromDataChange = (event, type) => {
        const { addUserInfoFromData, addUserInfoFromDataError } = this.state;
        let tempAddUserInfoFromData = Object.assign({}, addUserInfoFromData);
        let tempAddUserInfoFromDataError = Object.assign(
            {},
            addUserInfoFromDataError
        );

        if (type == "city") {
            if (event.target.value != "") {
                tempAddUserInfoFromData["city"] = event.target.value;
                tempAddUserInfoFromDataError["city"] = "";
            } else {
                tempAddUserInfoFromData["city"] = "";
                tempAddUserInfoFromDataError["city"] = "";
            }
        }
        if (type == "country") {
            if (event.target.value != "") {
                tempAddUserInfoFromData["country"] = event.target.value;
                tempAddUserInfoFromDataError["country"] = "";
            } else {
                tempAddUserInfoFromData["country"] = "";
                tempAddUserInfoFromDataError["country"] = "";
            }
        }
        if (type == "phone_no") {
            if (event.target.value != "") {
                tempAddUserInfoFromData["phone_no"] = event.target.value;
                tempAddUserInfoFromDataError["phone_no"] = "";
            } else {
                tempAddUserInfoFromData["phone_no"] = "";
                tempAddUserInfoFromDataError["phone_no"] = "";
            }
        }
        this.setState(
            {
                addUserInfoFromData: tempAddUserInfoFromData,
                addUserInfoFromDataError: tempAddUserInfoFromDataError,
                //saveButtonDisableEditModal: false
            },
            () => {
                //console.log("addUserInfoFromData====",this.state.addUserInfoFromData)
            }
        );
    };

    addUserImageChanged = (event) => {
        let { addUserFromData } = this.state;
        let targetFileSplit = event.target.files[0].name.split(".");
        let lastElement = targetFileSplit.pop();
        let user_profile_image = {
            file_name: "",
            file_obj: "",
        };
        if (
            lastElement == "JPEG" ||
            lastElement == "jpeg" ||
            lastElement == "jpg" ||
            lastElement == "JPG" ||
            lastElement == "png" ||
            lastElement == "PNG" ||
            lastElement == ""
        ) {
            const fsize = event.target.files[0].size;
            const file = Math.round(fsize / 1024);
            if (file >= 300) {
                Utility.toastNotifications(
                    "File is too Big, please select a file less than 300kb",
                    "Warning",
                    "warning"
                );
            } else {
                this.setState({
                    imageCropModalFlag: true,
                });
                if (event.target.files && event.target.files.length > 0) {
                    const reader = new FileReader();
                    reader.addEventListener("load", () =>
                        this.setState({ src: reader.result })
                    );
                    reader.readAsDataURL(event.target.files[0]);
                    user_profile_image["file_name"] = event.target.files[0].name;
                    user_profile_image["file_obj"] = "";
                    addUserFromData["profileImage"] = user_profile_image;
                    this.setState({
                        addUserFromData,
                        addUserImagePreviewShow: true,
                        addUserImageError: "",
                        userDataEditFlag: true,
                        imageEditFrom: "user",
                    });
                }
            }
        } else {
            addUserFromData["profileImage"] = "";

            this.setState({
                addUserFromData,
                addUserImagePreviewShow: false,
                addUserImageSelected: "Add Image",
                addUserImageError: "Required field",
                userDataEditFlag: true,
            });
        }
    };

    addEditUser = () => {
        let valid = this.validAddUserData();
        // console.log('Edit--------->')
        const { loaderStateTrue, loaderStateFalse } = this.props;
        const { addUserFromData, gridObjData } = this.state;

        if (valid) {
            let data = this.formatingUserData();

            let method = "post";
            let id = "";
            let addUserDataSet = [data.add];

            if (addUserFromData.user_id != "") {
                (id = addUserFromData.user_id), (method = "patch");
                addUserDataSet = data.update;
            }

            //return false;

            loaderStateTrue();
            OrganizationController.addUser(addUserDataSet, method, id)
                .then((response) => {
                    loaderStateFalse();
                    if (method == "post") {
                        if (response[0].success) {
                            this.orgCustRelation(response[0].data[0].id).then(
                                (orgCustRelationResponse) => {
                                    if (orgCustRelationResponse) {
                                        this.closeUserModal();
                                        //this.closeOrganizationModal()
                                        this.resetDataGrid();
                                        Utility.toastNotifications(
                                            response[0].message,
                                            "Success",
                                            "success"
                                        );
                                    }
                                }
                            );
                            this.adminUsersInfo(
                                response[0].data[0].id,
                                response[0].data[0].user_number,
                                "newCreate"
                            );
                        } else {
                            Utility.toastNotifications(response[0].message, "Error", "error");
                        }
                    } else {
                        if (response.success) {
                            if (gridObjData?.data?.admins?.length > 0) {
                                //let userNumber = gridObjData?.data?.admins[0]?.user_number
                                let userId =
                                    gridObjData?.data?.admins[0]?.personal_information?.user_id;
                                //this.adminUsersInfo(userId, userNumber, "alreadyCreated")
                                this.adminUsersInfo(userId, null, "alreadyCreated");
                            }

                            this.closeUserModal();
                            this.closeOrganizationModal();
                            this.resetDataGrid();
                            Utility.toastNotifications(
                                response.message,
                                "Success",
                                "success"
                            );
                        } else {
                            Utility.toastNotifications(response.message, "Error", "error");
                        }
                    }
                })
                .catch((error) => {
                    //console.error("************error*************", error)
                    //console.log("error============", error)
                    if (error) {
                        //Utility.toastNotifications(error.message, "Error", "error");
                    }
                    loaderStateFalse();
                    if (error.message == "Network Error") {
                        // Utility.toastNotifications("Please login", "Error", "error");
                        // this.props.logOutApp().then(
                        //     () => this.props.history.push("/")
                        // );
                    }
                    if (error.response.status == 409) {
                        Utility.toastNotifications(
                            error.response.data.message,
                            "Error",
                            "error"
                        );
                    }
                });
        }
    };

    orgCustRelation = (userId) => {
        let promise = new Promise((resolve, reject) => {
            const { loaderStateTrue, loaderStateFalse } = this.props;
            const { addUserFromData, gridObjData } = this.state;

            let data = [
                {
                    org_id: gridObjData.data.id,
                    user_id: userId,
                },
            ];
            loaderStateTrue();
            OrganizationController.orgCustRelationPost(data)
                .then((response) => {
                    loaderStateFalse();
                    if (response[0].success) {
                        resolve(response);
                    } else {
                        Utility.toastNotifications(response[0].message, "Error", "error");
                    }
                })
                .catch((error) => {
                    //console.error("************error*************", error)
                    if (error) {
                        //Utility.toastNotifications(error.message, "Error", "error");
                    }
                    loaderStateFalse();
                    if (error.message == "Network Error") {
                        // Utility.toastNotifications("Please login", "Error", "error");
                        // this.props.logOutApp().then(
                        //     () => this.props.history.push("/")
                        // );
                    }
                });
        });
        return promise;
    };

    validAddUserData = () => {
        const {
            addUserFromData,
            addUserFromDataError,
            addUserImageError,
            addUserInfoFromData,
            addUserInfoFromDataError,
        } = this.state;
        let tempAddUserFromDataError = Object.assign({}, addUserFromDataError);
        let tempAddUserInfoFromDataError = Object.assign(
            {},
            addUserInfoFromDataError
        );

        let valid = true;
        if (addUserFromData.name == "") {
            tempAddUserFromDataError["name"] = "Required field";
            valid = false;
        } else {
            tempAddUserFromDataError["name"] = "";
        }

        if (addUserFromData.email == "") {
            tempAddUserFromDataError["email"] = "Required field";
            valid = false;
        } else {
            var expr = /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
            if (!expr.test(addUserFromData.email)) {
                tempAddUserFromDataError["email"] = "Enter valid email";
                valid = false;
            } else {
                tempAddUserFromDataError["email"] = "";
            }
        }

        if (addUserImageError != "") {
            valid = false;
        }

        let phoneValidate = HomeUtility.validate_Phone_Number(
            addUserInfoFromData.phone_no
        );
        if (addUserInfoFromData.phone_no != "") {
            if (phoneValidate) {
                tempAddUserInfoFromDataError["phone_no"] = "";
            } else {
                tempAddUserInfoFromDataError["phone_no"] = "Enter correct phone number";
                valid = false;
            }
        }
        /*if(!valid){
                return false
            }*/

        this.setState({
            addUserFromDataError: tempAddUserFromDataError,
            addUserInfoFromDataError: tempAddUserInfoFromDataError,
        });

        return valid;
    };

    formatingUserData = () => {
        const { addUserFromData } = this.state;
        //console.log("addUserFromData==>>", addUserFromData)

        let tempHash = {};
        tempHash["add"] = {};
        tempHash["update"] = {};
        if (addUserFromData.user_id == "") {
            tempHash["add"]["name"] =
                addUserFromData.name != "" ? addUserFromData.name : "";
            tempHash["add"]["email"] =
                addUserFromData.email != "" ? addUserFromData.email : "";
            tempHash["add"]["type"] = "admin";
            //tempHash["add"]['phone_no'] = addUserFromData.phone != "" ? addUserFromData.phone : "";
            //tempHash["add"]['address'] = addUserFromData.address != "" ? addUserFromData.address.toString() : "";
            tempHash["add"]["status"] = addUserFromData.status ? 1 : 0;
            if (Object.keys(addUserFromData.profileImage).length > 0) {
                tempHash["add"]["profile_img"] = addUserFromData.profileImage;
            }
        } else {
            tempHash["update"]["name"] =
                addUserFromData.name != "" ? addUserFromData.name : "";
            tempHash["update"]["email"] =
                addUserFromData.email != "" ? addUserFromData.email : "";
            tempHash["update"]["type"] = "admin";
            //tempHash["update"]['phone_no'] = addUserFromData.phone != "" ? addUserFromData.phone : "";
            //tempHash["update"]['address'] = addUserFromData.address != "" ? addUserFromData.address.toString() : "";
            tempHash["update"]["status"] = addUserFromData.status ? 1 : 0;
            if (Object.keys(addUserFromData.profileImage).length > 0) {
                tempHash["update"]["profile_img"] = addUserFromData.profileImage;
            }
        }

        return tempHash;
    };

    formatingInfoUserData = (type) => {
        const { addUserInfoFromData } = this.state;
        //console.log("addUserInfoFromData==>>", addUserInfoFromData)
        let tempHash = {};
        tempHash["add"] = {};
        tempHash["update"] = {};
        if (type == "newCreate") {
            tempHash["add"]["phone_no"] =
                addUserInfoFromData.phone_no != "" ? addUserInfoFromData.phone_no : "";
            tempHash["add"]["city"] =
                addUserInfoFromData.city != ""
                    ? addUserInfoFromData.city.toString()
                    : "";
            tempHash["add"]["country"] =
                addUserInfoFromData.country != ""
                    ? addUserInfoFromData.country.toString()
                    : "";
        } else {
            tempHash["update"]["phone_no"] =
                addUserInfoFromData.phone_no != "" ? addUserInfoFromData.phone_no : "";
            tempHash["update"]["city"] =
                addUserInfoFromData.city != ""
                    ? addUserInfoFromData.city.toString()
                    : "";
            tempHash["update"]["country"] =
                addUserInfoFromData.country != ""
                    ? addUserInfoFromData.country.toString()
                    : "";
        }
        return tempHash;
    };

    deleteUser = (params) => {
        //console.log("params=========", params)
        this.setState({
            deleteUserConfirmationAlertModal: true,
            actionModalflag: false,
            userDeleteBodySecondContent: params.data.admins[0].user_name,
            userDeleteObj: params.data,
        });
    };

    deleteUserConfirmationModalHide = () => {
        this.setState({
            deleteUserConfirmationAlertModal: false,
            userDeleteBodySecondContent: "",
        });
    };

    userDeleteCancleButton = () => {
        this.deleteUserConfirmationModalHide();
    };

    userDeleteConfirmButton = () => {
        this.userDeleteApi();
    };

    userDeleteApi = () => {
        const { userDeleteObj } = this.state;
        //console.log("userDeleteObj",userDeleteObj)
        const { loaderStateTrue, loaderStateFalse } = this.props;
        loaderStateTrue();
        let data = {};
        data["id"] = [userDeleteObj.admins[0].id];

        OrganizationController.userDelete(data)
            .then((response) => {
                if (response.success) {
                    this.resetDataGrid();
                    this.deleteUserConfirmationModalHide();
                    this.resetOrganizationFrom();
                    Utility.toastNotifications(
                        response.data[0].message,
                        "Success",
                        "success"
                    );
                } else {
                    Utility.toastNotifications(
                        response.data[0].message,
                        "Error",
                        "error"
                    );
                }
                loaderStateFalse();
            })
            .catch((error) => {
                //console.error("************error*************", error)
                if (error) {
                    //Utility.toastNotifications(error.message, "Error", "error");
                }
                loaderStateFalse();
                if (error.message == "Network Error") {
                }
            });
    };

    cancelAddUserData = () => {
        this.setState({
            addUserFromData: {
                name: "",
                email: "",
                phone: "",
                address: "",
                profileImage: "",
                status: true,
                user_id: "",
            },

            addUserFromDataError: {
                name: "",
                email: "",
            },
            addUserInfoFromData: {
                city: "",
                country: "",
                phone_no: "",
            },
            addUserInfoFromDataError: {
                city: "",
                country: "",
                phone_no: "",
            },
            userDataEditFlag: false,
            addUserImagePreviewShow: false,
            addUserImageSelected: require("../../../Utility/Public/images/profile-back.png"),
            addUserImageError: "",
            //saveButtonDisableEditModal: true,
        });
    };

    popoverStickDatasetFormatUser = (rowData) => {
        let data = {};
        //console.log("rowDatarowData", rowData)
        data = Object.assign(rowData, {
            email: rowData.admins.length > 0 ? rowData.admins[0].user_email : "",
            phone_no: rowData.admins.length > 0 ? rowData.admins[0].user_ph_no : "",
        });
        return data;
    };

    adminUsersInfoValid = () => {
        const { addUserInfoFromData, addUserInfoFromDataError } = this.state;
        let tempAddUserInfoFromDataError = Object.assign(
            {},
            addUserInfoFromDataError
        );
        let valid = true;
        let phoneValidate = HomeUtility.validate_Phone_Number(
            addUserInfoFromData.phone_no
        );
        if (addUserInfoFromData.phone_no != "") {
            if (phoneValidate) {
                tempAddUserInfoFromDataError["phone_no"] = "";
            } else {
                tempAddUserInfoFromDataError["phone_no"] = "Enter correct phone number";
                valid = false;
            }
        }
        this.setState({
            addUserInfoFromDataError: tempAddUserInfoFromDataError,
        });
        return valid;
    };

    adminUsersInfo = (userId, user_number, type) => {
        let promise = new Promise((resolve, reject) => {
            let valid = this.adminUsersInfoValid();
            const { loaderStateTrue, loaderStateFalse } = this.props;
            const { addUserInfoFromData, gridObjData } = this.state;
            //console.log("valid", valid)
            if (valid) {
                let data = this.formatingInfoUserData(type);

                let method = "post";
                let id = "";
                let addUserDataSet;
                //return false;

                if (type == "alreadyCreated") {
                    (id = userId), (method = "patch");
                    addUserDataSet = data.update;
                    //addUserDataSet.user_id = userId
                    //addUserDataSet.examinee_id = user_number.split("-")[1]
                } else {
                    addUserDataSet = [data.add];
                    addUserDataSet[0].user_id = userId;
                    addUserDataSet[0].examinee_id = user_number.split("-")[1];
                }
                //console.log("addUserDataSet==========>",addUserDataSet)
                loaderStateTrue();

                OrganizationController.usersInfo(addUserDataSet, id, method)
                    .then((response) => {
                        //console.log("response=====", response)
                        loaderStateFalse();
                        if (method == "post") {
                            if (response.length > 0) {
                                response.map((res, index) => {
                                    if (res.success) {
                                        this.closeUserModal();
                                        this.resetDataGrid();
                                        Utility.toastNotifications(
                                            res.message,
                                            "Success",
                                            "success"
                                        );
                                    } else {
                                        Utility.toastNotifications(res.message, "Error", "error");
                                    }
                                });
                            }
                        } else {
                            if (response.success) {
                                this.closeUserModal();
                                this.closeOrganizationModal();
                                this.resetDataGrid();
                                Utility.toastNotifications(
                                    response.message,
                                    "Success",
                                    "success"
                                );
                            } else {
                                Utility.toastNotifications(response.message, "Error", "error");
                            }
                        }
                    })
                    .catch((error) => {
                        console.error("************error*************", error);
                        if (error) {
                            //Utility.toastNotifications(error.message, "Error", "error");
                        }
                        loaderStateFalse();
                        if (error.message == "Network Error") {
                            // Utility.toastNotifications("Please login", "Error", "error");
                            // this.props.logOutApp().then(
                            //     () => this.props.history.push("/")
                            // );
                        }
                        if (error.response.status == 400) {
                            Utility.toastNotifications(
                                error.response.data.message,
                                "Error",
                                "error"
                            );
                        }
                    });
            }
        });
        return promise;
    };

    //file upload code start
    dropDocumentFileChange = (files, event) => {
        if (files.length == 1) {
            let fileName = files[0].name.split(".");
            let extension = fileName.pop();
            let marketed_by_logo_url = {
                file_name: "",
                file_obj: "",
            };
            if (
                extension.toLowerCase() == "jpg" ||
                extension.toLowerCase() == "jpeg" ||
                extension.toLowerCase() == "png"
            ) {
                const fsize = files[0].size;
                const file = Math.round(fsize / 1024);
                if (file >= 5120) {
                    Utility.toastNotifications(
                        this.props.t("fileUploadAlert"),
                        "Warning",
                        "warning"
                    );
                } else {
                    this.getBase64MarketedLogoUrl(files[0], (result) => {
                        // user_profile_image["file_name"] = event.target.files[0].name
                        // user_profile_image["file_obj"] = ""
                        // fromData["profileImage"] = user_profile_image
                        let _hash = {};
                        _hash["file_name"] = files[0].name;
                        _hash["file_obj"] = result;
                        //console.log("_hash=======",_hash)
                        this.setState(
                            {
                                documentObjfileObj: _hash,
                                documentObjFileName: files[0].name,
                                documentError: "",
                                //saveButtonDisableEditModal: false,
                            },
                            () => {
                                // console.log("documentObjfileObj=========", this.state.documentObjfileObj)
                            }
                        );
                    });
                }
            } else {
                Utility.toastNotifications(
                    this.props.t("fileTypeAlert"),
                    "Warning",
                    "warning"
                );
            }
        } else {
            this.setState({
                documentObjfileObj: "",
                documentObjFileName: this.props.t("choosefile"),
                documentError: this.props.t("pleaseselectonefile"),
                documentError: "",
            });
        }
    };

    getBase64MarketedLogoUrl(file, cb) {
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
            cb(reader.result);
        };
        reader.onerror = function (error) {
            //console.log('Error: ', error);
        };
    }

    uploadDocumentFileChange = (event) => {
        if (event.target.files.length == 1) {
            let fileName = event.target.files[0].name.split(".");
            let extension = fileName.pop();
            if (
                extension.toLowerCase() == "jpg" ||
                extension.toLowerCase() == "jpeg" ||
                extension.toLowerCase() == "png"
            ) {
                const fsize = event.target.files[0].size;
                const file = Math.round(fsize / 1024);
                if (file >= 5120) {
                    Utility.toastNotifications(
                        this.props.t("fileUploadAlert"),
                        "Warning",
                        "warning"
                    );
                } else {
                    this.getBase64MarketedLogoUrl(event.target.files[0], (result) => {
                        let _hash = {};
                        _hash["file_name"] = event.target.files[0].name;
                        _hash["file_obj"] = result;
                        //console.log("_hash=======",_hash)
                        this.setState(
                            {
                                documentObjfileObj: _hash,
                                documentObjFileName: event.target.files[0].name,
                                //saveButtonDisableEditModal: false,
                                //orgDataEditFlag: true,
                            },
                            () => {
                                //console.log("documentObjfileObj=========", this.state.documentObjfileObj)
                            }
                        );
                    });
                }
            } else {
                Utility.toastNotifications(
                    this.props.t("fileTypeAlert"),
                    "Warning",
                    "warning"
                );
            }
        } else {
            this.setState({
                documentObjfileObj: "",
                documentObjFileName: this.props.t("choosefile"),
                documentError: this.props.t("pleaseselectonefile"),
            });
        }
    };

    // checkbox handler function

    handleChangeVersionFn = (e) => {
        let fromDataTemp = { ...this.state.fromData };
        let fromDataTempError = { ...this.state.fromDataError };

        if (e.value === "") {
            fromDataTempError["selectedVersion"] = "Required field";
            fromDataTemp["selectedVersion"] = [];
            this.setState({
                fromData: fromDataTemp,
                fromDataError: fromDataTempError,
            });
        } else {
            const versionLabel = e.label?.toLowerCase().trim();
            const isV6 = versionLabel.startsWith("v6");

            fromDataTemp["selectedVersion"] = [e];
            fromDataTemp["user_count"] = e.user_count || "";
            fromDataTempError["selectedVersion"] = "";
            fromDataTempError["user_count"] = "";

            // If V6, make sure default message values are initialized
            if (isV6) {
                fromDataTemp["marketing_message"] =
                    fromDataTemp["marketing_message"] || "";
                fromDataTemp["utility_message"] = fromDataTemp["utility_message"] || "";
            } else {
                delete fromDataTemp["marketing_message"];
                delete fromDataTemp["utility_message"];
            }
            if (isV6) {
                this.setState({
                    fromData: fromDataTemp,
                    fromDataError: fromDataTempError,
                    handleChangeVersionFlag: true,
                    isCheckboxChecked: isV6,
                    showMessageCountFields: isV6,
                });
            } else {
                this.setState({
                    fromData: fromDataTemp,
                    fromDataError: fromDataTempError,
                    handleChangeVersionFlag: true,
                });
            }
        }
    };

    handleCheckboxToggle = () => {
        this.setState((prevState) => ({
            isCheckboxChecked: !prevState.isCheckboxChecked,
            showMessageCountFields: !prevState.showMessageCountFields,
        }));
    };

    formatDateInput = (type) => {
        const { fromData } = this.state;
        if (type == "contractEndDate") {
            // console.log(' fromData.contractEndDate.month==================>', (fromData.contractEndDate.month).toString().padStart(2, 0))

            if (fromData.contractEndDate == "") return "";
            const Year = fromData.contractEndDate.year.toString();
            const Month = fromData.contractEndDate.month.toString().padStart(2, 0);
            const Day = fromData.contractEndDate.day.toString().padStart(2, 0);
            return `${Day}/${Month}/${Year}`;
        }
        if (type == "contractStartDate") {
            if (fromData.contractStartDate == "") return "";
            const Year = fromData.contractStartDate.year.toString();
            const Month = fromData.contractStartDate.month.toString().padStart(2, 0);
            const Day = fromData.contractStartDate.day.toString().padStart(2, 0);
            return `${Day}/${Month}/${Year}`;
        }
    };

    handleChangeContractDate = (type, date) => {
        const { fromData, fromDataError } = this.state;
        if (type == "contractStartDate") {
            let fromDataTemp = Object.assign({}, fromData);
            let fromDataTempError = Object.assign({}, fromDataError);
            if (date == "") {
                fromDataTemp["contractStartDate"] = "";
                fromDataTemp["contractEndDate"] = "";
            } else {
                fromDataTemp["contractStartDate"] = date;
                fromDataTemp["contractEndDate"] = "";
                fromDataTempError["contractStartDate"] = "";
            }
            this.setState(
                {
                    fromData: fromDataTemp,
                    fromDataError: fromDataTempError,
                    // freeTrialSubscription: false,
                    // monthlySubscription: false,
                    // yearlySubscription: false
                },
                () => {
                    // console.log('fromData===============>', fromData)
                }
            );
        }
        if (type == "contractEndDate") {
            let fromDataTemp = Object.assign({}, fromData);
            let fromDataTempError = Object.assign({}, fromDataError);
            if (date == "") {
                fromDataTemp["contractEndDate"] = "";
            } else {
                fromDataTemp["contractEndDate"] = date;

                fromDataTempError["contractEndDate"] = "";
            }
            this.setState(
                {
                    fromData: fromDataTemp,
                    fromDataError: fromDataTempError,
                    // freeTrialSubscription: false,
                    // monthlySubscription: false,
                    // yearlySubscription: false
                },
                () => {
                    // console.log('fromData===============>', fromData)
                }
            );
        }
    };

    handleChangeSubscriptionChange = (event, type) => {
        let fromDataTemp = Object.assign({}, this.state.fromData);
        let fromDataErrorTemp = Object.assign({}, this.state.fromDataError);

        const { checked } = event.target;

        let formattedStartContractDate = "";
        let tempcontract_start_date = new Date();

        let formattedEndContractDate = "";
        let tempcontract_end_date = new Date();

        if (type == "freeTrial") {
            if (checked) {
                tempcontract_end_date.setDate(tempcontract_end_date.getDate() + 15);

                formattedStartContractDate = {
                    year: tempcontract_start_date.getFullYear(),
                    month: tempcontract_start_date.getMonth() + 1,
                    day: tempcontract_start_date.getDate(),
                };
                formattedEndContractDate = {
                    year: tempcontract_end_date.getFullYear(),
                    month: tempcontract_end_date.getMonth() + 1,
                    day: tempcontract_end_date.getDate(),
                };
                fromDataTemp = {
                    ...fromDataTemp,
                    contractStartDate: formattedStartContractDate,
                    contractEndDate: formattedEndContractDate,
                };
                fromDataErrorTemp = {
                    ...fromDataErrorTemp,
                    contractStartDate: "",
                    contractEndDate: "",
                };
                this.setState({
                    freeTrialSubscription: checked,
                    monthlySubscription: false,
                    yearlySubscription: false,
                    fromData: fromDataTemp,
                    fromDataError: fromDataErrorTemp,
                });
            } else {
                fromDataTemp = {
                    ...fromDataTemp,
                    contractStartDate: "",
                    contractEndDate: "",
                };
                this.setState({
                    freeTrialSubscription: false,
                    monthlySubscription: false,
                    yearlySubscription: false,
                    fromData: fromDataTemp,
                });
            }
        }
        if (type == "monthly") {
            if (checked) {
                tempcontract_end_date.setMonth(tempcontract_end_date.getMonth() + 1);

                formattedStartContractDate = {
                    year: tempcontract_start_date.getFullYear(),
                    month: tempcontract_start_date.getMonth() + 1,
                    day: tempcontract_start_date.getDate(),
                };
                formattedEndContractDate = {
                    year: tempcontract_end_date.getFullYear(),
                    month: tempcontract_end_date.getMonth() + 1,
                    day: tempcontract_end_date.getDate(),
                };
                fromDataTemp = {
                    ...fromDataTemp,
                    contractStartDate: formattedStartContractDate,
                    contractEndDate: formattedEndContractDate,
                };
                fromDataErrorTemp = {
                    ...fromDataErrorTemp,
                    contractStartDate: "",
                    contractEndDate: "",
                };
                this.setState({
                    freeTrialSubscription: false,
                    monthlySubscription: checked,
                    yearlySubscription: false,
                    fromData: fromDataTemp,
                    fromDataError: fromDataErrorTemp,
                });
            } else {
                fromDataTemp = {
                    ...fromDataTemp,
                    contractStartDate: "",
                    contractEndDate: "",
                };
                this.setState({
                    freeTrialSubscription: false,
                    monthlySubscription: false,
                    yearlySubscription: false,
                    fromData: fromDataTemp,
                });
            }
        }
        if (type == "yearly") {
            if (checked) {
                tempcontract_end_date.setFullYear(
                    tempcontract_end_date.getFullYear() + 1
                );

                formattedStartContractDate = {
                    year: tempcontract_start_date.getFullYear(),
                    month: tempcontract_start_date.getMonth() + 1,
                    day: tempcontract_start_date.getDate(),
                };
                formattedEndContractDate = {
                    year: tempcontract_end_date.getFullYear(),
                    month: tempcontract_end_date.getMonth() + 1,
                    day: tempcontract_end_date.getDate(),
                };
                fromDataTemp = {
                    ...fromDataTemp,
                    contractStartDate: formattedStartContractDate,
                    contractEndDate: formattedEndContractDate,
                };
                fromDataErrorTemp = {
                    ...fromDataErrorTemp,
                    contractStartDate: "",
                    contractEndDate: "",
                };
                this.setState({
                    freeTrialSubscription: false,
                    monthlySubscription: false,
                    yearlySubscription: checked,
                    fromData: fromDataTemp,
                    fromDataError: fromDataErrorTemp,
                });
            } else {
                fromDataTemp = {
                    ...fromDataTemp,
                    contractStartDate: "",
                    contractEndDate: "",
                };
                this.setState({
                    freeTrialSubscription: false,
                    monthlySubscription: false,
                    yearlySubscription: false,
                    fromData: fromDataTemp,
                });
            }
        }
    };

    zoominFunction = () => {
        //console.log("-----zoom in ------------")
        let zoominzoomoutflag = "zoominzoomoutclass";
        this.setState({
            zoominzoomoutflag: zoominzoomoutflag,
        });
    };
    zoomoutFunction = () => {
        //console.log("-----zoom out ------------")
        let zoominzoomoutflag = "";
        this.setState({
            zoominzoomoutflag: zoominzoomoutflag,
        });
    };

    whatsappBusinessPhoneNumberInputHandleChangeFn = (phone_number) => {
        const { whatsappBusinessPhoneNumber } = this.state;

        let whatsappBusinessPhoneNumberTemp = whatsappBusinessPhoneNumber;
        if (phone_number != "") {
            let phoneValidate = HomeUtility.validate_Phone_Number_without_plus(
                phone_number
            );
            // console.log("phoneValidate======", phoneValidate)
            if (phoneValidate) {
                whatsappBusinessPhoneNumberTemp = phone_number;
                this.setState({
                    // handleChangeUserInformationPhoneNumberFlag: true,
                    whatsappBusinessPhoneNumberError: "",
                });
            } else {
                whatsappBusinessPhoneNumberTemp = phone_number;
                this.setState({
                    // handleChangeUserInformationPhoneNumberFlag: true,
                    whatsappBusinessPhoneNumberError: "Enter valid phone number",
                });
            }
        } else {
            whatsappBusinessPhoneNumberTemp = "";
            this.setState({
                // handleChangeUserInformationPhoneNumberFlag: true,
                // phoneNumberError: "Enter a phone number"
            });
        }
        this.setState(
            {
                whatsappBusinessPhoneNumber:
                    Config.phoneNumberWithOrwithoutPlus +
                    "" +
                    whatsappBusinessPhoneNumberTemp,
            },
            () => {
                // console.log("whatsappBusinessPhoneNumber===", this.state.whatsappBusinessPhoneNumber);
            }
        );
    };

    handleChangeActiveOrgNoteFn = () => {
        let whatsappBusinessPhoneNumberNoteTemp = this.state
            .whatsappBusinessPhoneNumberNote;
        this.setState({
            whatsappBusinessPhoneNumberNote: !whatsappBusinessPhoneNumberNoteTemp,
        });
    };

    getCallChangeCatelog = () => {
        const { gridObjData } = this.state;
        let phoneNumberId = gridObjData.data.phone_number_id;
        let version = "v18.0";
        let url = `https://graph.facebook.com/${version}/${phoneNumberId}/whatsapp_commerce_settings`;
        let accessToken = gridObjData.data.token;
        let headers = {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
        };

        axios
            .get(url, { headers })
            .then((response) => {
                // console.log('Response:===========', response);
                if (
                    response.hasOwnProperty("data") &&
                    response.data.data[0].is_catalog_visible == true
                ) {
                    this.setState({
                        changeCatelogToggle: true,
                    });
                } else {
                    this.setState({
                        changeCatelogToggle: false,
                    });
                }
            })
            .catch((error) => {
                this.setState({
                    changeCatelogToggle: false,
                });
            });
    };

    handleChangeCatalogue = () => {
        const { gridObjData } = this.state;
        this.setState(
            {
                changeCatelogToggle: !this.state.changeCatelogToggle,
            },
            () => {
                let phoneNumberId = gridObjData.data.phone_number_id;
                let version = "v18.0";
                let url = `https://graph.facebook.com/${version}/${phoneNumberId}/whatsapp_commerce_settings`;
                let accessToken = gridObjData.data.token;
                let headers = {
                    Authorization: `Bearer ${accessToken}`,
                    "Content-Type": "application/json",
                };
                let dataToSend = {
                    is_cart_enabled: this.state.changeCatelogToggle,
                    is_catalog_visible: this.state.changeCatelogToggle,
                };

                axios
                    .post(url, dataToSend, { headers })
                    .then((response) => {
                        // console.log('changeCatelogToggle Response:===========', response.data);
                    })
                    .catch((error) => {
                        this.setState({
                            changeCatelogToggle: false,
                        });
                    });
            }
        );
    };

    viewCheckListModalHide = () => {
        this.setState({
            viewCheckListModal: false,
        });
    };

    handleActivatePhoneNumber = () => {
        //imtiaj
        let data = {};
        const { gridObjData } = this.state;
        data["org_id"] = gridObjData.data.id;
        OrganizationController.orgActivatePhoneNumber(data)
            .then((response) => {
                if (response) {
                    if (response.success) {
                        this.setState({
                            disableActivePhnnoButton:
                                response.data.whatsapp_phone_number_activated,
                        });

                        this.createOrganisationSetting(gridObjData.data);
                        Utility.toastNotifications(response.message, "Success", "success");
                    } else {
                        this.setState({
                            disableActivePhnnoButton: false,
                        });
                        Utility.toastNotifications(response.message, "Error", "error");
                    }
                }
            })
            .catch((error) => {
                if (error) {
                    Utility.toastNotifications(error.message, "Error", "error");
                    this.setState({
                        disableActivePhnnoButton: false,
                    });
                }
                if (error.response.status === 406) {
                    //this.resetDataGrid()
                }
                // loaderStateFalse();
                if (error.message == "Network Error") {
                }
            });
    };

    orgWisesettingDataGet = () => {
        const { loaderStateTrue, loaderStateFalse } = this.props;

        let dataHash = {};
        let filters = {};
        dataHash["org_id"] = this.state.gridObjData.data.id;
        filters["filters"] = JSON.stringify(dataHash);

        loaderStateTrue();
        OrganizationController.controlPanelGetApi(filters)
            .then((responseData) => {
                if (responseData.success) {
                    let response = responseData.data;
                    const gridScreenNames = [
                        ...new Set(
                            response
                                .filter((item) =>
                                    (item.ui_element_type === this.state.selectedTab) ==
                                        "tab_captions"
                                        ? "tab"
                                        : "grid"
                                )
                                .map((item) => item.screen_name)
                        ),
                    ];
                    if (response.length > 0) {
                        this.setState(
                            {
                                viewControlPannelModal: true,
                                ControlPannelModalDataset: gridScreenNames,
                                selectedTab: "tab_captions",
                                settingmasterData: response,
                            },
                            () => {
                                this.screenOptions();
                            }
                        );
                        loaderStateFalse();
                    }
                }
            })
            .catch((error) => {
                if (error) {
                    Utility.toastNotifications(error.message, "Error", "error");
                }
                if (error.response.status === 406) {
                    //this.resetDataGrid()
                }
                // loaderStateFalse();
                if (error.message == "Network Error") {
                }
            });
    };

    // for control pannel
    controlPannelModal = (data) => {
        this.orgWisesettingDataGet();
    };

    controlPannelModalHide = () => {
        this.setState({
            viewControlPannelModal: false,
            orgNameControlPannelModal: "",
            selectedTab: "tab_captions",
            screenOptionsData: [],
            tabScreenOptionsSelectedValue: "",
            gridScreenOptionsSelectedValue: "",
            tabScreenTableData: [],
            gridScreenTableData: [],
            tabScreenOptionsSelectedError: "",
            gridScreenOptionsSelectedError: "",
            settingData: "",
        });
    };

    handelSelectTab = (tabname) => {
        let response = this.state.settingmasterData;
        // const gridScreenNames = [...new Set(response.filter(item => item.ui_element_type === tabname == "tab_captions" ? "tab" : "grid").map(item => item.screen_name))];

        const gridScreenNames = [
            ...new Set(
                response
                    .filter((item) =>
                        tabname === "tab_captions"
                            ? item.ui_element_type === "tab"
                            : item.ui_element_type === "grid"
                    )
                    .map((item) => item.screen_name)
            ),
        ];

        this.setState(
            {
                selectedTab: tabname,
                uniqIdentifierOptionsData: [],
                ControlPannelModalDataset: gridScreenNames,
                tabScreenOptionsSelectedValue: "",
                uniqIdentifier: "",
                settingData: "",
                settingDataError: [],
            },
            () => {
                this.screenOptions();
            }
        );
    };

    screenOptions = () => {
        const { ControlPannelModalDataset } = this.state;
        if (ControlPannelModalDataset.length > 0) {
            let tempScreenArry = [];
            ControlPannelModalDataset.map((item) => {
                let screenHash = {};
                screenHash["label"] = item.replaceAll("_", " ");
                screenHash["value"] = item;
                tempScreenArry.push(screenHash);
                this.setState({
                    screenOptionsData: tempScreenArry,
                });
            });
        }
    };

    screenHandleChangeFn = (e, selected_tab) => {
        if (e != null) {
            //if (selected_tab == "tab_captions") {
            this.setState(
                {
                    tabScreenOptionsSelectedValue: e,
                    uniqIdentifier: "",
                    settingData: "",
                    settingDataError: [],
                },
                () => {
                    // this.getTabScreenData(selected_tab)
                }
            );
            // } else {
            //     this.setState({
            //         gridScreenOptionsSelectedValue: e
            //     }, () => {
            //         //this.getGridScreenData(selected_tab)
            //     })
            // }

            let tempMasterData = this.state.settingmasterData;
            const uniqIdentifierOptionsDataName = [
                ...new Set(
                    tempMasterData
                        .filter(
                            (item) =>
                                (this.state.selectedTab === "tab_captions"
                                    ? item.ui_element_type === "tab"
                                    : item.ui_element_type === "grid") &&
                                item.screen_name === e.value
                        )
                        .map((item) => item.uniq_identifier)
                ),
            ];

            let uniqIdentifierArry = [];
            uniqIdentifierOptionsDataName.map((item) => {
                let screenHash = {};
                screenHash["label"] = item.replaceAll("_", " ");
                screenHash["value"] = item;
                uniqIdentifierArry.push(screenHash);
                this.setState({
                    uniqIdentifierOptionsData: uniqIdentifierArry,
                });
            });
        }
    };

    screenHandleChangeUniqIdentifier = (e, type) => {
        if (e != null) {
            this.setState(
                {
                    uniqIdentifier: e,
                },
                () => {
                    let tempMasterData = this.state.settingmasterData;
                    const settingDataString = [
                        ...new Set(
                            tempMasterData
                                .filter(
                                    (item) =>
                                        (this.state.selectedTab === "tab_captions"
                                            ? item.ui_element_type === "tab"
                                            : item.ui_element_type === "grid") &&
                                        item.screen_name ===
                                        this.state.tabScreenOptionsSelectedValue.value &&
                                        item.uniq_identifier === e.value
                                )
                                .map((item) => item.setting_data)
                        ),
                    ];

                    if (
                        this.state.tabScreenOptionsSelectedValue.value ==
                        "notification history"
                    ) {
                        let parsedata =
                            settingDataString.length > 0 && JSON.parse(settingDataString[0]);
                        let modified_tab_settings_data = this.moveCampaignBroadcastingToEnd(
                            parsedata
                        );
                        this.setState({
                            settingData:
                                settingDataString.length > 0
                                    ? JSON.stringify(modified_tab_settings_data)
                                    : "",
                        });
                    } else {
                        this.setState({
                            settingData:
                                settingDataString.length > 0 ? settingDataString[0] : "",
                        });
                    }
                }
            );
        }
    };

    moveCampaignBroadcastingToEnd = (arr) => {
        const result = [];
        let campaignBroadcastingItem = null;

        for (const item of arr) {
            if (item.field_name === "CampaignBroadcasting") {
                campaignBroadcastingItem = item;
            } else {
                result.push(item);
            }
        }

        if (campaignBroadcastingItem) {
            result.push(campaignBroadcastingItem);
        }

        return result;
    };

    getTabScreenData = (selected_tab) => {
        const { tabScreenOptionsSelectedValue } = this.state;
        let dataset = {};
        let tab = selected_tab == "tab_captions" ? "tab" : "grid";
        dataset["filter"] = {
            screen_name: tabScreenOptionsSelectedValue.value,
            ui_element_type: tab,
        };
        // console.log("dataset=====", dataset)
        // OrganizationController.controlSettings("get", false, dataset).then((response) => {
        //     console.log("response=============>>", response)
        // })
        let response = {
            status: "success",
            data: [
                {
                    screen_name: "Notification",
                    ui_element_type: "Tab",
                    field_name: "leads_tab",
                    field_caption: "Leads",
                    modified_field_caption: "Prospective Students",
                    field_value: null,
                    current_status: 1,
                    created_at: "2024-09-23T12:30:00Z",
                    updated_at: "2024-09-23T13:00:00Z",
                    created_by: 101,
                },
                {
                    screen_name: "Notification",
                    ui_element_type: "Tab",
                    field_name: "opportunity_tab",
                    field_caption: "Opportunity",
                    modified_field_caption: null,
                    field_value: null,
                    current_status: 0,
                    created_at: "2024-09-23T12:30:00Z",
                    updated_at: "2024-09-23T13:00:00Z",
                    created_by: 101,
                },
            ],
        };
        const tabDataset = response.data.filter(
            (item) => item.ui_element_type == "Tab"
        );
        // console.log("tabDataset=====", tabDataset)
        if (response.data.length > 0) {
            this.setState({
                tabScreenTableData: tabDataset,
            });
        }
    };

    getGridScreenData = (selected_tab) => {
        const { gridScreenOptionsSelectedValue } = this.state;
        let dataset = {};
        let tab = selected_tab == "tab_captions" ? "tab" : "grid";
        dataset["filter"] = {
            screen_name: gridScreenOptionsSelectedValue.value,
            ui_element_type: tab,
        };
        // console.log("dataset=====", dataset)
        // OrganizationController.controlSettings("get", false, dataset).then((response) => {
        //     console.log("response=============>>", response)
        // })
        let response = {
            status: "success",
            data: [
                {
                    screen_name: "Notification",
                    ui_element_type: "Grid",
                    field_name: "opportunity_tab",
                    field_caption: "Opportunity",
                    modified_field_caption: "Student Name",
                    field_value: null,
                    current_status: 1,
                    created_at: "2024-09-23T12:30:00Z",
                    updated_at: "2024-09-23T13:00:00Z",
                    created_by: 101,
                },
                {
                    screen_name: "Notification",
                    ui_element_type: "Grid",
                    field_name: "campaign_broadcasting_tab",
                    field_caption: "Contact",
                    modified_field_caption: "Group/Member",
                    field_value: null,
                    current_status: 0,
                    created_at: "2024-09-23T12:30:00Z",
                    updated_at: "2024-09-23T13:00:00Z",
                    created_by: 101,
                },
            ],
        };
        const gridDataset = response.data.filter(
            (item) => item.ui_element_type == "Grid"
        );
        // console.log("gridDataset=====", gridDataset)
        if (response.data.length > 0) {
            this.setState({
                gridScreenTableData: gridDataset,
            });
        }
    };

    handleChangeTextCaptions = (e, rowIndex) => {
        let tempsettingData =
            this.state.settingData != "" ? JSON.parse(this.state.settingData) : "";
        let tempsettingDataError = [...this.state.settingDataError];

        if (tempsettingData.length > 0) {
            tempsettingData.map((value, idx) => {
                if (rowIndex == idx) {
                    value["modified_field_caption"] = e.target.value;
                    if (
                        tempsettingDataError.hasOwnProperty(rowIndex) &&
                        tempsettingDataError[rowIndex].message != ""
                    ) {
                        tempsettingDataError[rowIndex]["message"] = "";
                    }
                }
            });
            this.setState(
                {
                    settingData: JSON.stringify(tempsettingData),
                    settingDataError: tempsettingDataError,
                },
                () => {
                    // console.log("this.state.tempsettingData=========", this.state.settingData)
                }
            );
        }
    };

    handleChangeActiveButton = (e, rowIndex) => {
        let tempsettingData =
            this.state.settingData != "" ? JSON.parse(this.state.settingData) : "";
        if (tempsettingData.length > 0) {
            tempsettingData.map((value, idx) => {
                if (rowIndex == idx) {
                    value["current_status"] = e.target.checked == true ? 1 : 0;
                }
            });
            this.setState({ settingData: JSON.stringify(tempsettingData) }, () => {
                // console.log("this.state.tempsettingData=========", this.state.settingData)
            });
        }
    };

    dataValidation = () => {
        const {
            selectedTab,
            tabScreenOptionsSelectedValue,
            gridScreenOptionsSelectedValue,
        } = this.state;
        let valid = true;
        if (selectedTab == "tab_captions") {
            if (tabScreenOptionsSelectedValue == "") {
                valid = false;
                this.setState({
                    tabScreenOptionsSelectedError: "Select screen",
                });
            } else {
                this.setState({
                    tabScreenOptionsSelectedError: "",
                });
            }
        }
        if (selectedTab == "grid_field_labels") {
            if (gridScreenOptionsSelectedValue == "") {
                valid = false;
                this.setState({
                    gridScreenOptionsSelectedError: "Select screen",
                });
            } else {
                this.setState({
                    gridScreenOptionsSelectedError: "",
                });
            }
        }
        return valid;
    };

    saveControlSetting = () => {
        const { loaderStateTrue, loaderStateFalse } = this.props;
        let valid = this.ValidControllPanelData();
        // console.log("saving control======", valid)
        if (valid) {
            loaderStateTrue();
            let dataSet = this.masterDataSet();
            OrganizationController.controlPanel(dataSet)
                .then((response) => {
                    if (response.length > 0) {
                        loaderStateFalse();
                        Utility.toastNotifications(
                            response[0].message,
                            "Success",
                            "success"
                        );
                        this.controlPannelModalHide();
                        this.setState({
                            screenOptionsData: "",
                            uniqIdentifierOptionsData: "",
                            uniqIdentifier: "",
                            tabScreenOptionsSelectedValue: "",
                            settingData: "",
                            settingDataError: [],
                        });
                    }
                })
                .catch((error) => {
                    if (error) {
                        Utility.toastNotifications(error.message, "Error", "error");
                    }
                    if (error.response.status === 406) {
                        //this.resetDataGrid()
                    }
                    // loaderStateFalse();
                    if (error.message == "Network Error") {
                    }
                });
        }
    };

    ValidControllPanelData = () => {
        let tempsettingDataErrorData = this.state.settingDataError;
        let tempsettingData =
            this.state.settingData != "" ? JSON.parse(this.state.settingData) : "";
        let tempsettingDataErrorArry = [];
        let valid = true;
        if (tempsettingData.length > 0) {
            tempsettingData.map((item, idx) => {
                let settingDataHashError = {};
                if (item.modified_field_caption == "") {
                    settingDataHashError["message"] = "Required field";
                    valid = false;
                } else {
                    settingDataHashError["message"] = "";
                }
                tempsettingDataErrorArry.push(settingDataHashError);
            });
        }
        this.setState({
            settingDataError: tempsettingDataErrorArry,
        });
        return valid;
    };

    masterDataSet = () => {
        let hash = {};
        hash["org_id"] = this.state.gridObjData.data.id;
        hash["screen_name"] = this.state.tabScreenOptionsSelectedValue.value;
        hash["ui_element_type"] =
            this.state.selectedTab === "tab_captions" ? "tab" : "grid";
        hash["uniq_identifier"] = this.state.uniqIdentifier.value;
        hash["setting_data"] = this.state.settingData;
        return [hash];
    };
    // control pannel end

    // for webhook setting
    webhookSettingModal = () => {
        this.masterDataSetWebhookSetting();
    };

    masterDataSetWebhookSetting = () => {
        const { webhookSettingText, gridObjData } = this.state;
        // console.log("gridObjData=======", gridObjData);
        this.setState(
            {
                webhookSettingText: {
                    fb_token_text: gridObjData?.data?.token
                        ? gridObjData.data.token.toString()
                        : "",
                    client_id_text: gridObjData?.data?.whatsapp_business_account_id
                        ? gridObjData.data.whatsapp_business_account_id
                        : 0,
                    whatsapp_account_id_text: gridObjData?.data?.phone_number_id
                        ? gridObjData.data.phone_number_id
                        : 0,
                    event_call_back_api_text: gridObjData?.data?.event_callback_url
                        ? gridObjData.data.event_callback_url
                        : "",
                },
            },
            () => {
                this.setState({ viewWebhookSettingModal: true });
            }
        );
    };

    webhookSettingModalHide = () => {
        this.setState({
            viewWebhookSettingModal: false,
            webhookSettingText: {
                fb_token_text: "",
                client_id_text: "",
                whatsapp_account_id_text: "",
                event_call_back_api_text: "",
            },
            webhookSettingError: {
                fb_token_error: "",
                client_id_error: "",
                whatsapp_account_id_error: "",
                event_call_back_api_error: "",
            },
        });
    };

    handleChangeTextWebhook = (e, type) => {
        const { webhookSettingText } = this.state;
        const newWebhookSettingText = {
            ...webhookSettingText,
            [type]: e.target.value,
        };

        this.setState({ webhookSettingText: newWebhookSettingText });
    };

    validateWebhookSettingData = () => {
        const { webhookSettingText, webhookSettingError } = this.state;
        let valid = true;
        const newWebhookSettingError = { ...webhookSettingError };

        // Validate fb_token_text
        if (webhookSettingText.fb_token_text === "") {
            newWebhookSettingError.fb_token_error = "Required field";
            valid = false;
        } else {
            newWebhookSettingError.fb_token_error = "";
        }

        // Validate client_id_text
        if (webhookSettingText.client_id_text === "") {
            newWebhookSettingError.client_id_error = "Required field";
            valid = false;
        } else {
            newWebhookSettingError.client_id_error = "";
        }

        // Validate whatsapp_account_id_text
        if (webhookSettingText.whatsapp_account_id_text === "") {
            newWebhookSettingError.whatsapp_account_id_error = "Required field";
            valid = false;
        } else {
            newWebhookSettingError.whatsapp_account_id_error = "";
        }

        // Validate event_call_back_api_text
        if (webhookSettingText.event_call_back_api_text === "") {
            newWebhookSettingError.event_call_back_api_error = "Required field";
            valid = false;
        } else {
            newWebhookSettingError.event_call_back_api_error = "";
        }

        // Update state with new error messages
        this.setState({ webhookSettingError: newWebhookSettingError });

        return valid;
    };

    formatDatasetWebhookSetting = () => {
        const { webhookSettingText } = this.state;
        let webhook_settings_data = {
            // "fb_token": webhookSettingText && webhookSettingText.hasOwnProperty('fb_token_text') && webhookSettingText.fb_token_text !== "" ? webhookSettingText.fb_token_text.toString() : "",
            // "client_id": webhookSettingText && webhookSettingText.hasOwnProperty('client_id_text') && webhookSettingText.client_id_text !== "" ? parseInt(webhookSettingText.client_id_text) : 0,
            // "whatsapp_account_id": webhookSettingText && webhookSettingText.hasOwnProperty('whatsapp_account_id_text') && webhookSettingText.whatsapp_account_id_text !== "" ? parseInt(webhookSettingText.whatsapp_account_id_text) : 0,
            event_callback_url:
                webhookSettingText &&
                    webhookSettingText.hasOwnProperty("event_call_back_api_text") &&
                    webhookSettingText.event_call_back_api_text !== ""
                    ? webhookSettingText.event_call_back_api_text.toString()
                    : "",
        };
        return webhook_settings_data;
    };

    saveWebhookSetting = () => {
        const { loaderStateTrue, loaderStateFalse } = this.props;
        const { gridObjData } = this.state;
        let valid = this.validateWebhookSettingData();
        if (valid) {
            loaderStateTrue();
            let dataset = this.formatDatasetWebhookSetting();
            let has_already_data = gridObjData?.data?.is_registered;
            let method = has_already_data ? "patch" : "post";
            dataset["org_id"] = gridObjData.data.id;
            // console.log("method=======", method)
            console.log("dataset=======", dataset);
            // loaderStateFalse();
            // return false;
            OrganizationController.webhookSettingPanel(dataset, method)
                .then((response) => {
                    // console.log("response=======", response)
                    if (response.success) {
                        loaderStateFalse();
                        Utility.toastNotifications(
                            "Webhook updated successfully",
                            "Success",
                            "success"
                        );
                        this.webhookSettingModalHide();
                        this.loadGrid();
                    } else {
                        loaderStateFalse();
                        Utility.toastNotifications(response.message, "Error", "error");
                    }
                    loaderStateFalse();
                })
                .catch((error) => {
                    // console.log("error==========", error.response.data)
                    if (error) {
                        Utility.toastNotifications(error.message, "Error", "error");
                    }
                    if (error.response.status === 400) {
                        Utility.toastNotifications(
                            error.response.data.message,
                            "Error",
                            "error"
                        );
                    }
                    loaderStateFalse();
                });
        }
    };
    // end webhook setting

    handleOnBlurChange = (e) => {
        if (e.target.value != "") {
            let inputValue = e.target.value;
            let capitalizedValue = inputValue;
            let newData = { label: capitalizedValue, value: capitalizedValue };
            this.setState((prevState) => ({
                tagsValue: [...prevState.tagsValue, newData],
            }));
        }
    };
    handleKeyDownChangeTags = (e) => {
        if (e.key === "Enter") {
            if (e.target.value != "") {
                let inputValue = e.target.value;
                let capitalizedValue = inputValue;
                let newData = { label: capitalizedValue, value: capitalizedValue };
                this.setState((prevState) => ({
                    tagsValue: [...prevState.tagsValue, newData],
                }));
            }
        }
    };

    handleChangeTags = (e) => {
        if (e) {
            this.setState({
                tagsValue: e,
            });
        } else {
            this.setState({
                tagsValue: [],
            });
        }
    };

    render() {
        //console.log("userProfileId===tr props",this.props.userProfileId)
        // const { t, roleWisePermission } = this.props;
        const {
            tabScreenOptionsSelectedValue,
            gridScreenOptionsSelectedValue,
            uniqIdentifier,
        } = this.state;
        let roleName =
            this.props.userCredentials.hasOwnProperty("user_details") &&
            this.props.userCredentials.user_details &&
            this.props.userCredentials.user_details.hasOwnProperty("user_type") &&
            this.props.userCredentials.user_details.user_type;
        return (
            <div className="gridcontainer">
                <div className="totalworkercontent">
                    <ErrorBoundary title="GlobalHeaderFilter Error">
                        <GlobalHeaderFilter
                            headerFliterContent={
                                <>
                                    <ErrorBoundary title="OrganisationFilterContent Error">
                                        <OrganisationFilterContent
                                            organizationModalfunction={this.organizationModalfunction}
                                            handleUserSearchBar={this.handleUserSearchBar}
                                            orgName={this.state.orgName}
                                            clearSearchValue={this.clearSearchValue}
                                            totalDatasetCount={this.state.totalDatasetCount}
                                        />
                                    </ErrorBoundary>
                                </>
                            }
                        />
                    </ErrorBoundary>
                    <div className="ag-theme-alpine aggridview homeag orgGrid">
                        <div className="refreshButtonInner">
                            <button
                                className="buttonload"
                                onClick={() => {
                                    this.loadGrid();
                                }}
                                data-tip="Refresh data"
                            >
                                <i className="fa fa-refresh"></i>
                            </button>
                            <ReactTooltip place="bottom" />
                        </div>
                        <AgGridReact
                            modules={this.state.modules}
                            // columnDefs={this.state.columnDefs}
                            columnDefs={this.state.columnDefs.map((colDef) => ({
                                ...colDef,
                                cellClass: "vertical_center",
                            }))}
                            defaultColDef={this.state.defaultColDef}
                            components={this.state.components}
                            rowSelection="multiple"
                            rowModelType="infinite"
                            onGridReady={this.onGridReady}
                            rowHeight={50}
                            headerHeight={47}
                            //onSelectionChanged={this.onSelectionChanged.bind(this)}
                            cacheBlockSize={20}
                            enableRtl={
                                localStorage.getItem("selected_lan_direction") == "rtl"
                                    ? true
                                    : false
                            }
                            gridOptions={this.gridOptions}
                        />
                    </div>
                    <ErrorBoundary title="ModalGlobal Error">
                        <ModalGlobal
                            show={this.state.organizationModal}
                            onHide={this.closeOrganizationModal}
                            title={this.state.orgAddEditModalTitle}
                            //className="modalcustomize mondimension orgModal"
                            className={` ${this.state.zoominzoomoutflag +
                                " " +
                                "modalcustomize mondimension orgModal"}`}
                            footer={false}
                            closeButton={true}
                            zoominButton={this.state.zoominzoomoutflag != "" ? false : true}
                            zoomoutButton={this.state.zoominzoomoutflag != "" ? true : false}
                            zoomin={this.zoominFunction}
                            zoomout={this.zoomoutFunction}
                            body={
                                <>
                                    <ErrorBoundary title="OrganizationModalContent Error">
                                        <OrganizationModalContent
                                            //Image crop
                                            addInputProfileImageChanged={
                                                this.addInputProfileImageChanged
                                            }
                                            addprofileImageSelected={
                                                this.state.addprofileImageSelected
                                            }
                                            crop={this.state.crop}
                                            croppedImageUrl={this.state.croppedImageUrl}
                                            src={this.state.src}
                                            onImageLoaded={this.onImageLoaded}
                                            onCropComplete={this.onCropComplete}
                                            onCropChange={this.onCropChange}
                                            imageCropModalShow={this.imageCropModalShow}
                                            imageCropModalHide={this.imageCropModalHide}
                                            imageCropModalFlag={this.state.imageCropModalFlag}
                                            imageCropDataSave={this.imageCropDataSave}
                                            closeOrganizationModal={this.closeOrganizationModal}
                                            //form data
                                            handelChange={this.handelChange}
                                            fromData={this.state.fromData}
                                            fromDataError={this.state.fromDataError}
                                            statusList={this.state.statusList}
                                            addCustomer={this.addCustomer}
                                            addProfileImagePreviewShow={
                                                this.state.addProfileImagePreviewShow
                                            }
                                            //Add user From Data for Edit
                                            addUserImageSelected={this.state.addUserImageSelected}
                                            addEditUser={this.addEditUser}
                                            addUserFromDataChange={this.addUserFromDataChange}
                                            addUserFromData={this.state.addUserFromData}
                                            addUserFromDataError={this.state.addUserFromDataError}
                                            addUserImageError={this.state.addUserImageError}
                                            addUserImageChanged={this.addUserImageChanged}
                                            //orgDataEditFlag={this.state.orgDataEditFlag}
                                            userDataEditFlag={this.state.userDataEditFlag}
                                            onCropCompleteForUser={this.onCropCompleteForUser}
                                            imageEditFrom={this.state.imageEditFrom}
                                            addUserImagePreviewShow={
                                                this.state.addUserImagePreviewShow
                                            }
                                            //saveButtonDisableEditModal={this.state.saveButtonDisableEditModal}

                                            addUserInfoFromDataError={
                                                this.state.addUserInfoFromDataError
                                            }
                                            addUserInfoFromData={this.state.addUserInfoFromData}
                                            addUserInfoFromDataChange={this.addUserInfoFromDataChange}
                                            dropDocumentFileChange={this.dropDocumentFileChange}
                                            uploadDocumentFileChange={this.uploadDocumentFileChange}
                                            documentObjFileName={this.state.documentObjFileName}
                                            documentError={this.state.documentError}
                                            versionOption={this.state.versionOption}
                                            handleChangeVersionFn={this.handleChangeVersionFn}
                                            // checkbox input boxes
                                            isCheckboxChecked={this.state.isCheckboxChecked}
                                            showMessageCountFields={this.state.showMessageCountFields}
                                            onCheckboxToggle={this.handleCheckboxToggle}
                                            handleChangeContractDate={this.handleChangeContractDate}
                                            formatDateInput={this.formatDateInput}
                                            freeTrialSubscription={this.state.freeTrialSubscription}
                                            monthlySubscription={this.state.monthlySubscription}
                                            yearlySubscription={this.state.yearlySubscription}
                                            handleChangeSubscriptionChange={
                                                this.handleChangeSubscriptionChange
                                            }
                                            whatsappBusinessPhoneNumber={
                                                this.state.whatsappBusinessPhoneNumber
                                            }
                                            whatsappBusinessPhoneNumberError={
                                                this.state.whatsappBusinessPhoneNumberError
                                            }
                                            whatsappBusinessPhoneNumberInputHandleChangeFn={
                                                this.whatsappBusinessPhoneNumberInputHandleChangeFn
                                            }
                                            handleChangeActiveOrgNoteFn={
                                                this.handleChangeActiveOrgNoteFn
                                            }
                                            whatsappBusinessPhoneNumberNote={
                                                this.state.whatsappBusinessPhoneNumberNote
                                            }
                                            //imtiaj // for activate button
                                            disableActivePhnnoButton={
                                                this.state.disableActivePhnnoButton
                                            }
                                            handleActivatePhoneNumber={this.handleActivatePhoneNumber}
                                            //imtiaj for catalouge button
                                            handleChangeCatalogue={this.handleChangeCatalogue}
                                            changeCatelogToggle={this.state.changeCatelogToggle}
                                            orgAddEditModalTitle={this.state.orgAddEditModalTitle}
                                            //
                                            handleChangeTags={this.handleChangeTags}
                                            handleKeyDownChangeTags={this.handleKeyDownChangeTags}
                                            handleOnBlurChange={this.handleOnBlurChange}
                                            tagsOptions={this.state.tagsOptions}
                                            tagsValue={this.state.tagsValue}
                                        />
                                    </ErrorBoundary>
                                </>
                            }
                        />
                    </ErrorBoundary>

                    <ErrorBoundary title="ModalGlobal Error">
                        <ModalGlobal
                            show={this.state.deleteConfirmationAlertModal}
                            onHide={this.deleteConfirmationModalHide}
                            className="modalcustomize confirmationalertmodal"
                            bodyClassName="cancelConfirmationbody"
                            headerclassName="close_btn_icon"
                            title="Delete this organization?"
                            footer={false}
                            body={
                                <>
                                    <ErrorBoundary title="ConfirmationAlert Error">
                                        <ConfirmationAlert
                                            BodyFirstContent="Do you confirm the deletion of the"
                                            BodySecondContent={this.state.orgDeleteBodySecondContent}
                                            BodyThirdContent="organization definitely? You won't be able to go back."
                                            confirmationButtonContent="confirm"
                                            cancelButtonContent="cancel"
                                            deleteConfirmButton={this.orgDeleteConfirmButton}
                                            deleteCancleButton={this.orgDeleteCancleButton}
                                        />
                                    </ErrorBoundary>
                                </>
                            }
                        />
                    </ErrorBoundary>

                    {/* =========for control pannel======= */}
                    {/* {console.log("data=========",this.state.gridObjData)} */}
                    <ErrorBoundary title="ModalGlobal Error">
                        <ModalGlobal
                            show={this.state.viewControlPannelModal}
                            onHide={this.controlPannelModalHide}
                            className={`${this.state.zoominzoomoutflag +
                                " " +
                                "modalcustomize control_pannel_modal"}`}
                            title={`Control Pannel Settings (${this.state.gridObjData?.data?.name})`}
                            footer={false}
                            closeButton={true}
                            minimizeModal={true}
                            maximizeModal={true}
                            zoominButton={this.state.zoominzoomoutflag != "" ? false : true}
                            zoomoutButton={this.state.zoominzoomoutflag != "" ? true : false}
                            zoomin={this.zoominFunction}
                            zoomout={this.zoomoutFunction}
                            body={
                                <>
                                    <div className="list_body">
                                        <ControlPannelModalContent
                                            selectedTab={this.state.selectedTab}
                                            handelSelectTab={this.handelSelectTab}
                                            screenOptions={this.screenOptions}
                                            screenOptionsData={this.state.screenOptionsData}
                                            screenHandleChangeFn={this.screenHandleChangeFn}
                                            tabScreenOptionsSelectedValue={
                                                this.state.tabScreenOptionsSelectedValue
                                            }
                                            gridScreenOptionsSelectedValue={
                                                this.state.gridScreenOptionsSelectedValue
                                            }
                                            tabScreenTableData={this.state.tabScreenTableData}
                                            gridScreenTableData={this.state.gridScreenTableData}
                                            tabScreenOptionsSelectedError={
                                                this.state.tabScreenOptionsSelectedError
                                            }
                                            gridScreenOptionsSelectedError={
                                                this.state.gridScreenOptionsSelectedError
                                            }
                                            handleChangeTextCaptions={this.handleChangeTextCaptions}
                                            handleChangeActiveButton={this.handleChangeActiveButton}
                                            screenHandleChangeUniqIdentifier={
                                                this.screenHandleChangeUniqIdentifier
                                            }
                                            uniqIdentifierOptionsData={
                                                this.state.uniqIdentifierOptionsData
                                            }
                                            uniqIdentifier={this.state.uniqIdentifier}
                                            settingData={this.state.settingData}
                                            settingDataError={this.state.settingDataError}
                                        />
                                    </div>
                                    {((tabScreenOptionsSelectedValue != "" &&
                                        uniqIdentifier != "") ||
                                        gridScreenOptionsSelectedValue != "") && (
                                            <div className="footer_btn_sec">
                                                <button
                                                    className="confirmButton"
                                                    onClick={this.saveControlSetting}
                                                >
                                                    Save
                                                </button>
                                                <button
                                                    className="cancelButton"
                                                    onClick={this.controlPannelModalHide}
                                                >
                                                    Cancel
                                                </button>
                                            </div>
                                        )}
                                </>
                            }
                        />
                    </ErrorBoundary>
                    {/* ========end========== */}

                    {/* /======= checklist start =============/ */}
                    <ErrorBoundary title="ModalGlobal Error">
                        <ModalGlobal
                            show={this.state.viewCheckListModal}
                            onHide={this.viewCheckListModalHide}
                            className="modalcustomize checkListModal"
                            title="Check List"
                            footer={false}
                            closeButton={true}
                            body={
                                <div className="list_body">
                                    <ErrorBoundary title="ConfirmationAlert Error">
                                        {this.state.orgSettingDataset.length > 0
                                            ? this.state.orgSettingDataset.map((val) => {
                                                if (val.key === "admin_reply_flow_id") {
                                                    return (
                                                        <React.Fragment key={val.key}>
                                                            <div className="org_setting_row_sec">
                                                                <span>Is available reply flow?</span>
                                                                <div className="row">
                                                                    <label className="checkboxcontainer">
                                                                        <input
                                                                            type="checkbox"
                                                                            checked={val.value && true}
                                                                            name="checkbox"
                                                                            disabled={val.value ? true : false}
                                                                        />
                                                                        <span className="checkmark"></span>
                                                                    </label>
                                                                </div>
                                                                {/* <span>
                                                                    <input
                                                                        type="checkbox"
                                                                        checked={val.value && true}
                                                                        className='all_checkbox'
                                                                        disabled={val.value ? true : false}
                                                                    />
                                                                </span> */}
                                                            </div>
                                                        </React.Fragment>
                                                    );
                                                } else if (val.key === "admin_reply_template_name") {
                                                    return (
                                                        <React.Fragment key={val.key}>
                                                            <div className="org_setting_row_sec">
                                                                <span>Is available reply template?</span>
                                                                <div className="row">
                                                                    <label className="checkboxcontainer">
                                                                        <input
                                                                            type="checkbox"
                                                                            checked={val.value && true}
                                                                            name="checkbox"
                                                                            disabled={val.value ? true : false}
                                                                        />
                                                                        <span className="checkmark"></span>
                                                                    </label>
                                                                </div>
                                                            </div>
                                                        </React.Fragment>
                                                    );
                                                } else if (
                                                    val.key === "whatsapp_phone_number_activated"
                                                ) {
                                                    return (
                                                        <React.Fragment key={val.key}>
                                                            <div className="org_setting_row_sec">
                                                                <span>
                                                                    Is activated whatsapp phone number?
                                                                </span>
                                                                <div className="row">
                                                                    <label className="checkboxcontainer">
                                                                        <input
                                                                            type="checkbox"
                                                                            checked={val.value == 1 ? true : false}
                                                                            name="checkbox"
                                                                            disabled={val.value ? true : false}
                                                                        />
                                                                        <span className="checkmark"></span>
                                                                    </label>
                                                                </div>
                                                            </div>
                                                        </React.Fragment>
                                                    );
                                                } else if (val.key === "admin_phone_numbers") {
                                                    return (
                                                        <React.Fragment key={val.key}>
                                                            <div className="org_setting_row_sec">
                                                                <span>Is available admin phone number?</span>
                                                                <div className="row">
                                                                    <label className="checkboxcontainer">
                                                                        <input
                                                                            type="checkbox"
                                                                            checked={val.value != "" ? true : false}
                                                                            name="checkbox"
                                                                            disabled={val.value ? true : false}
                                                                        />
                                                                        <span className="checkmark"></span>
                                                                    </label>
                                                                </div>
                                                            </div>
                                                        </React.Fragment>
                                                    );
                                                } else if (val.key === "enabled_openai_bot") {
                                                    return (
                                                        <React.Fragment key={val.key}>
                                                            <div className="org_setting_row_sec">
                                                                <span>Is enabled openai bot?</span>
                                                                <div className="row">
                                                                    <label className="checkboxcontainer">
                                                                        <input
                                                                            type="checkbox"
                                                                            checked={val.value == 1 ? true : false}
                                                                            name="checkbox"
                                                                            disabled={val.value ? true : false}
                                                                        />
                                                                        <span className="checkmark"></span>
                                                                    </label>
                                                                </div>
                                                            </div>
                                                        </React.Fragment>
                                                    );
                                                } else if (val.key === "default_auto_reply") {
                                                    return (
                                                        <React.Fragment key={val.key}>
                                                            <div className="org_setting_row_sec">
                                                                <span>Is it default auto reply?</span>
                                                                <div className="row">
                                                                    <label className="checkboxcontainer">
                                                                        <input
                                                                            type="checkbox"
                                                                            checked={val.value && true}
                                                                            name="checkbox"
                                                                            disabled={val.value ? true : false}
                                                                        />
                                                                        <span className="checkmark"></span>
                                                                    </label>
                                                                </div>
                                                            </div>
                                                        </React.Fragment>
                                                    );
                                                } else if (val.key === "admin_notification_message") {
                                                    return (
                                                        <React.Fragment key={val.key}>
                                                            <div className="org_setting_row_sec">
                                                                <span>
                                                                    Is available notification message?
                                                                </span>
                                                                <div className="row">
                                                                    <label className="checkboxcontainer">
                                                                        <input
                                                                            type="checkbox"
                                                                            checked={val.value && true}
                                                                            name="checkbox"
                                                                            disabled={val.value ? true : false}
                                                                        />
                                                                        <span className="checkmark"></span>
                                                                    </label>
                                                                </div>
                                                            </div>
                                                        </React.Fragment>
                                                    );
                                                } else {
                                                    return null;
                                                }
                                            })
                                            : null}
                                    </ErrorBoundary>
                                </div>
                            }
                        />
                    </ErrorBoundary>
                    {/* /======= checklist end =============/ */}

                    <ErrorBoundary title="ModalGlobal Error">
                        <ModalGlobal
                            show={this.state.deleteUserConfirmationAlertModal}
                            onHide={this.deleteUserConfirmationModalHide}
                            className="modalcustomize confirmationalertmodal"
                            bodyClassName="cancelConfirmationbody"
                            headerclassName="close_btn_icon"
                            title="Delete this user?"
                            footer={false}
                            body={
                                <>
                                    <ErrorBoundary title="ConfirmationAlert Error">
                                        <ConfirmationAlert
                                            BodyFirstContent="Do you confirm the deletion of the"
                                            BodySecondContent={this.state.userDeleteBodySecondContent}
                                            BodyThirdContent="user definitely? You won't be able to go back."
                                            confirmationButtonContent="confirm"
                                            cancelButtonContent="cancel"
                                            deleteConfirmButton={this.userDeleteConfirmButton}
                                            deleteCancleButton={this.userDeleteCancleButton}
                                        />
                                    </ErrorBoundary>
                                </>
                            }
                        />
                    </ErrorBoundary>

                    <ErrorBoundary title="ModalGlobal Error">
                        <ModalGlobal
                            show={this.state.addUserModalFlag}
                            onHide={this.closeUserModal}
                            title="Add User"
                            className="modalcustomize mondimension userModal"
                            footer={false}
                            closeButton={true}
                            body={
                                <>
                                    <ErrorBoundary title="AddUserModalContent Error">
                                        <AddUserModalContent
                                            //Image crop
                                            addInputProfileImageChanged={
                                                this.addInputProfileImageChanged
                                            }
                                            addUserImageSelected={this.state.addUserImageSelected}
                                            crop={this.state.crop}
                                            croppedImageUrl={this.state.croppedImageUrl}
                                            src={this.state.src}
                                            onImageLoaded={this.onImageLoaded}
                                            onCropCompleteForUser={this.onCropCompleteForUser}
                                            onCropChange={this.onCropChange}
                                            imageCropModalShow={this.imageCropModalShow}
                                            imageCropModalHide={this.imageCropModalHide}
                                            imageCropModalFlag={this.state.imageCropModalFlag}
                                            imageCropDataSave={this.imageCropDataSave}
                                            addUserImagePreviewShow={
                                                this.state.addUserImagePreviewShow
                                            }
                                            addEditUser={this.addEditUser}
                                            addUserFromDataChange={this.addUserFromDataChange}
                                            addUserFromData={this.state.addUserFromData}
                                            addUserFromDataError={this.state.addUserFromDataError}
                                            addUserImageError={this.state.addUserImageError}
                                            addUserImageChanged={this.addUserImageChanged}
                                            addUserInfoFromDataError={
                                                this.state.addUserInfoFromDataError
                                            }
                                            addUserInfoFromData={this.state.addUserInfoFromData}
                                            addUserInfoFromDataChange={this.addUserInfoFromDataChange}
                                        />
                                    </ErrorBoundary>
                                </>
                            }
                        />
                    </ErrorBoundary>

                    {/* =========for webhook setting pannel======= */}
                    <ErrorBoundary title="ModalGlobal Error">
                        <ModalGlobal
                            show={this.state.viewWebhookSettingModal}
                            onHide={this.webhookSettingModalHide}
                            className={`${this.state.zoominzoomoutflag +
                                " " +
                                "modalcustomize websetting_pannel_modal"}`}
                            title={`Webhook Settings (${this.state.gridObjData?.data?.name})`}
                            footer={false}
                            closeButton={true}
                            minimizeModal={true}
                            maximizeModal={true}
                            zoominButton={this.state.zoominzoomoutflag != "" ? false : true}
                            zoomoutButton={this.state.zoominzoomoutflag != "" ? true : false}
                            zoomin={this.zoominFunction}
                            zoomout={this.zoomoutFunction}
                            body={
                                <>
                                    <div className="list_body">
                                        <WebhookSettingsModalContent
                                            gridObjData={this.state.gridObjData}
                                            webhookSettingText={this.state.webhookSettingText}
                                            webhookSettingError={this.state.webhookSettingError}
                                            handleChangeTextWebhook={this.handleChangeTextWebhook}
                                        />
                                    </div>
                                    <div className="footer_btn_sec">
                                        <button
                                            className="confirmButton"
                                            onClick={this.saveWebhookSetting}
                                        >
                                            {this.state.gridObjData?.data?.is_registered
                                                ? "Update"
                                                : "Save"}
                                        </button>
                                        <button
                                            className="cancelButton"
                                            onClick={this.webhookSettingModalHide}
                                        >
                                            Cancel
                                        </button>
                                    </div>
                                </>
                            }
                        />
                    </ErrorBoundary>
                    {/* ========end========== */}
                    {this.state.actionModalflag ? (
                        <>
                            <ErrorBoundary title="GridActionContent Error">
                                <GridActionContent
                                    styleWidth={this.state.overlayWidth}
                                    styleHight={this.state.overlayHight}
                                    codeOutsideClickRef={this.codeOutsideClickRef}
                                    gridObjData={this.state.gridObjData}
                                    modefier={this.editOrganization}
                                    delete={this.deleteOrganization}
                                    checklist={this.viewChecklist}
                                    archivedButtonShow={false}
                                    deleteButtonShow={roleName == "app_admin" ? true : false}
                                    checkListButtonShow={roleName == "app_admin" ? true : false}
                                    // for control pannel
                                    controlPannelModal={this.controlPannelModal}
                                    controlPannelButtonShow={
                                        roleName == "app_admin" ? true : false
                                    }
                                    // end for control pannel
                                    // for webhook setting
                                    webhookSettingModal={this.webhookSettingModal}
                                    webhookSettingButtonShow={
                                        roleName == "app_admin" ? true : false
                                    }
                                // end for webhook setting
                                />
                            </ErrorBoundary>
                        </>
                    ) : null}
                </div>
            </div>
        );
    }
}

const mapStateToProps = (globalState) => {
    return {
        userCredentials: globalState.LoginReducer.userCredentials,
        roleWisePermission: globalState.mainReducerData.roleWisePermission,
        version: globalState.LoginReducer.version,
    };
};

export default withRouter(
    connect(
        mapStateToProps,
        {
            loaderStateTrue,
            loaderStateFalse,
            setToken,
            setUserCredentials,
            logOutApp,
        }
    )(withTranslation()(Organization))
);
